/* Cart drawer. Settings arrive in the section's script[data-ccd-config] block. */
(function () {
  var cfgEl = document.querySelector('script[data-ccd-config]');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}') || {}; } catch (e) {}
  var drawer = document.getElementById(cfg.drawerId);
  if (!drawer || drawer.dataset.ready === 'true') return;
  drawer.dataset.ready = 'true';

  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
  var moneyFormat = cfg.moneyFormat;
  var shopCurrency = cfg.shopCurrency;
  var localizationCurrency = cfg.localizationCurrency;
  var liquidCartCurrency = cfg.cartCurrency;
  var currencyOverride = normalizeCurrencyCode(cfg.currencyOverride);
  var shippingRateConversionEnabled = cfg.shippingRateConversion;
  var shippingRateSourceCurrency = normalizeCurrencyCode(cfg.shippingRateSourceCurrency) || 'USD';
  var shippingRateTargetCurrency = normalizeCurrencyCode(cfg.shippingRateTargetCurrency);
  var shippingRateManualRate = parsePositiveNumber(cfg.shippingRateManualRate, 1);
  var currentCartCurrency = currencyOverride || normalizeCurrencyCode(localizationCurrency) || normalizeCurrencyCode(liquidCartCurrency) || normalizeCurrencyCode(shopCurrency) || '';
  var currencyFormatters = {};
  var currencyRatesPromise = null;
  var sectionHandle = 'custom-cart-drawer';
  var sectionRequestIds = [cfg.sectionId, sectionHandle].filter(function (id, index, array) {
    return id && array.indexOf(id) === index;
  });
  var variantStockMap = readInlineStockMap(document);
  var immediateUpsellTemplates = readInlineImmediateUpsellTemplates(document);
  var itemsEl = drawer.querySelector('[data-drawer-items]');
  var upsellsEl = drawer.querySelector('[data-drawer-upsells]');
  var emptyEl = drawer.querySelector('[data-drawer-empty]');
  var loadingEl = drawer.querySelector('[data-drawer-loading]');
  var errorEl = drawer.querySelector('[data-drawer-error]');
  var globalWarnEl = drawer.querySelector('[data-drawer-global-warn]');
  var subtotalEl = drawer.querySelector('[data-drawer-subtotal]');
  var noteEl = drawer.querySelector('[data-cart-note]');
  var shippingCalculator = drawer.querySelector('[data-shipping-calculator]');
  var shippingCard = drawer.querySelector('[data-shipping-card]');
  var shippingToggles = drawer.querySelectorAll('[data-shipping-toggle]');
  var shippingCountry = drawer.querySelector('[data-shipping-country]');
  var shippingProvince = drawer.querySelector('[data-shipping-province]');
  var shippingZip = drawer.querySelector('[data-shipping-zip]');
  var shippingButton = drawer.querySelector('[data-shipping-calculate]');
  var shippingResult = drawer.querySelector('[data-shipping-result]');
  var ajaxForms = cfg.ajaxForms;
  var highValueCheckoutOnlyEnabled = cfg.highValueCheckoutOnly;
  var highValueCheckoutThresholdMajor = parsePositiveNumber(cfg.highValueCheckoutThreshold, 50000);
  var highValueCheckoutThresholdCurrency = normalizeCurrencyCode(cfg.highValueCheckoutThresholdCurrency) || 'USD';
  var acceleratedButtonsEl = drawer.querySelector('[data-accelerated-checkout-buttons]');
  var highValueMessageEl = drawer.querySelector('[data-high-value-checkout-message]');
  var checkoutFormEl = drawer.querySelector('[data-ccd-checkout-form]');
  var checkoutButtonEl = drawer.querySelector('[data-ccd-checkout-button]');
  var highValueModalEl = drawer.querySelector('[data-ccd-high-value-modal]');
  var highValueModalLastFocus = null;
  var highValueCurrencyRatesRequested = false;
  var highValueCurrencyRatesResolved = false;
  var lastCart = null;
  var requestModal = drawer.querySelector('[data-ccd-request-modal]');
  var requestBodyEl = drawer.querySelector('.ccd__request-body');
  var requestCartLinesEl = drawer.querySelector('[data-ccd-request-cart-lines]');
  var requestStatusEl = drawer.querySelector('[data-ccd-request-status]');
  var procurementListEl = drawer.querySelector('[data-ccd-procurement-list]');
  var requestActiveTab = 'bulk';
  var requestIntent = 'bulk';
  var ccdRefreshPromise = null;
  var ccdLastRefreshStartedAt = 0;
  var ccdCartActionInProgress = false;
  var ccdExternalRefreshTimer = null;
  var ccdLineMessages = {};
  var ccdLastInternalCartActionAt = 0;
  var ccdCartUiLockDepth = 0;
  var ccdQtyCommitTimers = typeof WeakMap === 'function' ? new WeakMap() : null;
  var ccdDrawerCloseTimer = null;
  var ccdRequestCloseTimer = null;

  function readInlineStockMap(context) {
    try {
      var source = context.querySelector('[data-ccd-stock-map]');
      if (!source) return {};
      return JSON.parse(source.textContent || '{}') || {};
    } catch (error) {
      console.warn('Cart drawer stock map parse failed:', error);
      return {};
    }
  }

  function readInlineUpsellHtml(context) {
    try {
      var source = context.querySelector('[data-ccd-upsell-html]');
      if (!source) return null;
      return JSON.parse(source.textContent || '""') || '';
    } catch (error) {
      console.warn('Cart drawer upsell HTML parse failed:', error);
      return null;
    }
  }

  function readInlineImmediateUpsellTemplates(context) {
    try {
      var source = context.querySelector('[data-ccd-immediate-upsell-html]');
      if (!source) return {};
      return JSON.parse(source.textContent || '{}') || {};
    } catch (error) {
      console.warn('Cart drawer immediate upsell template parse failed:', error);
      return {};
    }
  }

  function sectionRenderingUrl() {
    var base = window.location.pathname + window.location.search;
    var separator = base.indexOf('?') === -1 ? '?' : '&';
    return base + separator + 'sections=' + encodeURIComponent(sectionRequestIds.join(',')) + '&_ccd=' + Date.now();
  }

  function sectionIdRenderingUrl(sectionId) {
    var base = window.location.pathname + window.location.search;
    var separator = base.indexOf('?') === -1 ? '?' : '&';
    return base + separator + 'section_id=' + encodeURIComponent(sectionId) + '&_ccd=' + Date.now();
  }

  function applyRenderedSectionHtml(html) {
    if (!html) return variantStockMap;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var latest = readInlineStockMap(doc);
    var latestUpsells = readInlineUpsellHtml(doc);
    var latestImmediateTemplates = readInlineImmediateUpsellTemplates(doc);

    if (latest && Object.keys(latest).length) {
      variantStockMap = latest;
    }

    if (latestImmediateTemplates && Object.keys(latestImmediateTemplates).length) {
      immediateUpsellTemplates = latestImmediateTemplates;
    }

    if (upsellsEl && latestUpsells !== null) {
      upsellsEl.innerHTML = latestUpsells;
      upsellsEl.dataset.ccdImmediate = 'false';
    }

    return variantStockMap;
  }

  function renderedSectionHtml(sections) {
    if (!sections) return '';

    for (var i = 0; i < sectionRequestIds.length; i++) {
      if (sections[sectionRequestIds[i]]) {
        return sections[sectionRequestIds[i]];
      }
    }

    return '';
  }

  function fetchStockMap(cartForImmediateUpsell) {
    if (cartForImmediateUpsell) {
      renderClientSideConditionalUpsells(cartForImmediateUpsell);
    }

    return fetch(sectionRenderingUrl(), {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) { return response.json(); })
      .then(function (sections) {
        var html = renderedSectionHtml(sections);

        if (html) {
          return applyRenderedSectionHtml(html);
        }

        return fetch(sectionIdRenderingUrl(sectionRequestIds[0] || sectionHandle), {
          headers: { Accept: 'text/html' },
          credentials: 'same-origin',
          cache: 'no-store'
        })
          .then(function (response) {
            if (!response.ok) return '';
            return response.text();
          })
          .then(applyRenderedSectionHtml);
      })
      .catch(function (error) {
        console.warn('Cart drawer section refresh failed:', error);
        return variantStockMap;
      });
  }

  function lowStockBadge(item) {
    var raw = variantStockMap[String(item.variant_id)];
    var stock = Number(raw);

    if (!Number.isFinite(stock)) return '';

    if (stock > 0 && stock < 10) {
      return '<span class="ccd__low">Only ' + stock + ' left!</span>';
    }

    return '';
  }

  var ccdDefaultShippingCountry = cfg.defaultShippingCountry;

  function toggleShippingCalculator(forceOpen) {
    if (!shippingCalculator) return;

    var shouldOpen = typeof forceOpen === 'boolean'
      ? forceOpen
      : shippingCalculator.hidden;

    shippingCalculator.hidden = !shouldOpen;

    if (shippingCard) {
      shippingCard.classList.toggle('is-open', shouldOpen);
    }

    shippingToggles.forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    });

    if (shouldOpen && shippingZip) {
      setTimeout(function () {
        try { shippingZip.focus(); } catch (error) {}
      }, 80);
    }
  }

  function ensureValidShippingCountrySelection() {
    if (!shippingCountry || !shippingCountry.options || !shippingCountry.options.length) return;

    var current = shippingCountry.value;

    if (current && current !== '---') {
      return;
    }

    var preferredCountry = String(ccdDefaultShippingCountry || '').trim();
    var firstRealOption = null;

    for (var i = 0; i < shippingCountry.options.length; i++) {
      var option = shippingCountry.options[i];
      var value = String(option.value || '').trim();

      if (!value || value === '---') {
        continue;
      }

      if (!firstRealOption) {
        firstRealOption = option;
      }

      if (preferredCountry && value === preferredCountry) {
        option.selected = true;
        return;
      }
    }

    if (firstRealOption) {
      firstRealOption.selected = true;
    }
  }

  function renderShippingProvinces() {
    if (!shippingCountry || !shippingProvince) return;

    ensureValidShippingCountrySelection();

    var selectedOption = shippingCountry.options[shippingCountry.selectedIndex];
    var provinces = [];

    if (selectedOption) {
      try {
        provinces = JSON.parse(selectedOption.getAttribute('data-provinces') || '[]');
      } catch (error) {
        provinces = [];
      }
    }

    shippingProvince.innerHTML = '';

    if (!provinces.length) {
      shippingProvince.innerHTML = '<option value="">-</option>';
      shippingProvince.disabled = true;
      return;
    }

    shippingProvince.disabled = false;

    provinces.forEach(function (province, index) {
      var option = document.createElement('option');
      option.value = province[0];
      option.textContent = province[1];

      if (shippingCountry.value === 'United States' && province[0] === cfg.shippingDefaultState) {
        option.selected = true;
      } else if (index === 0) {
        option.selected = true;
      }

      shippingProvince.appendChild(option);
    });
  }

  function setShippingResult(message, isError) {
    if (!shippingResult) return;

    shippingResult.hidden = false;
    shippingResult.innerHTML = message;
    shippingResult.classList.toggle('is-error', !!isError);
  }

  function shippingQueryString() {
    var params = new URLSearchParams();

    params.append('shipping_address[country]', shippingCountry ? shippingCountry.value : '');
    params.append('shipping_address[province]', shippingProvince && !shippingProvince.disabled ? shippingProvince.value : '');
    params.append('shipping_address[zip]', shippingZip ? shippingZip.value.trim() : '');

    return params.toString();
  }

  function fetchAsyncShippingRates(query, attemptsRemaining) {
    return fetch(root + 'cart/async_shipping_rates.json?' + query, {
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      })
      .then(function (data) {
        if (!data || !Array.isArray(data.shipping_rates)) {
          if (attemptsRemaining > 1) {
            return new Promise(function (resolve) {
              setTimeout(resolve, 700);
            }).then(function () {
              return fetchAsyncShippingRates(query, attemptsRemaining - 1);
            });
          }

          throw { message: 'Shipping rates are not ready yet.' };
        }

        return data;
      });
  }

  function getShippingRates() {
    if (!shippingButton) return;

    var zip = shippingZip ? shippingZip.value.trim() : '';

    if (!zip) {
      setShippingResult(cfg.shippingMissingZipMessage, true);
      return;
    }

    shippingButton.classList.add('is-loading');
    shippingButton.disabled = true;
    setShippingResult('Calculating shipping...', false);

    var query = shippingQueryString();

    fetch(root + 'cart/prepare_shipping_rates.json?' + query, {
      method: 'POST',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) { throw data; });
        }
      })
      .then(function () {
        return fetchAsyncShippingRates(query, 6);
      })
      .then(function (data) {
        return ensureCurrencyConverter().then(function () {
          return data;
        });
      })
      .then(function (data) {
        var rates = data.shipping_rates || [];

        if (!rates.length) {
          setShippingResult(cfg.shippingNoRatesMessage, true);
          return;
        }

        var html = rates.map(function (rate) {
          var rateName = rate.presentment_name || rate.name || rate.code || 'Shipping';
          var price = formatShippingRatePrice(rate);
          var meta = shippingRateMeta(rate);

          return [
            '<div class="ccd__shipping-rate">',
              '<div class="ccd__shipping-rate-main">',
                '<strong>' + esc(rateName) + '</strong>',
                '<span class="ccd__shipping-rate-price">' + esc(price) + '</span>',
              '</div>',
              meta ? '<div class="ccd__shipping-rate-meta">' + meta + '</div>' : '',
            '</div>'
          ].join('');
        }).join('');

        setShippingResult(html, false);
      })
      .catch(function (error) {
        console.error('Shipping calculator error:', error);
        setShippingResult(cfg.shippingErrorMessage, true);
      })
      .finally(function () {
        shippingButton.classList.remove('is-loading');
        shippingButton.disabled = false;
      });
  }


  function normalizeCurrencyCode(code) {
    code = String(code || '').trim().toUpperCase();
    return /^[A-Z]{3}$/.test(code) ? code : '';
  }

  function parsePositiveNumber(value, fallback) {
    var cleaned = String(value == null ? '' : value).replace(',', '.').trim();
    var number = Number(cleaned);

    return Number.isFinite(number) && number > 0 ? number : fallback;
  }

  function currencyFromCart(cart) {
    if (!cart) return '';

    if (typeof cart.currency === 'string') {
      return normalizeCurrencyCode(cart.currency);
    }

    if (cart.currency && cart.currency.iso_code) {
      return normalizeCurrencyCode(cart.currency.iso_code);
    }

    return '';
  }

  function syncCartCurrency(cart) {
    var overrideCode = normalizeCurrencyCode(currencyOverride);
    var localizationCode = normalizeCurrencyCode(localizationCurrency);
    var cartCode = currencyFromCart(cart);
    var liquidCartCode = normalizeCurrencyCode(liquidCartCurrency);
    var shopCode = normalizeCurrencyCode(shopCurrency);

    currentCartCurrency = overrideCode || localizationCode || cartCode || liquidCartCode || shopCode || currentCartCurrency || '';
  }

  function activeCurrencyCode(fallbackCurrency) {
    var overrideCode = normalizeCurrencyCode(currencyOverride);
    var fallbackCode = normalizeCurrencyCode(fallbackCurrency);
    var localizationCode = normalizeCurrencyCode(localizationCurrency);
    var cartCode = normalizeCurrencyCode(currentCartCurrency);
    var shopifyCode = window.Shopify && Shopify.currency && Shopify.currency.active
      ? normalizeCurrencyCode(Shopify.currency.active)
      : '';
    var shopCode = normalizeCurrencyCode(shopCurrency);

    return overrideCode || localizationCode || cartCode || shopifyCode || fallbackCode || shopCode || '';
  }

  function ensureCurrencyConverter(forceLoad) {
    if (!shippingRateConversionEnabled && !forceLoad) {
      return Promise.resolve();
    }

    if (window.Currency && (typeof Currency.convert === 'function' || Currency.rates)) {
      return Promise.resolve();
    }

    if (currencyRatesPromise) {
      return currencyRatesPromise;
    }

    currencyRatesPromise = new Promise(function (resolve) {
      var existingScript = document.querySelector('script[data-ccd-currency-rates]');

      if (existingScript) {
        existingScript.addEventListener('load', function () { resolve(); });
        existingScript.addEventListener('error', function () { resolve(); });
        setTimeout(resolve, 1800);
        return;
      }

      var script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/s/javascripts/currencies.js';
      script.async = true;
      script.setAttribute('data-ccd-currency-rates', 'true');
      script.onload = function () { resolve(); };
      script.onerror = function () { resolve(); };

      document.head.appendChild(script);
      setTimeout(resolve, 1800);
    });

    return currencyRatesPromise;
  }

  function currencyConversionRate(fromCode, toCode) {
    var from = normalizeCurrencyCode(fromCode);
    var to = normalizeCurrencyCode(toCode);

    if (!from || !to || from === to) {
      return 1;
    }

    if (window.Currency && typeof Currency.convert === 'function') {
      try {
        var convertedUnit = Number(Currency.convert(1, from, to));

        if (Number.isFinite(convertedUnit) && convertedUnit > 0) {
          return convertedUnit;
        }
      } catch (error) {}
    }

    if (window.Currency && Currency.rates) {
      var fromRate = Number(Currency.rates[from]);
      var toRate = Number(Currency.rates[to]);

      if (Number.isFinite(fromRate) && fromRate > 0 && Number.isFinite(toRate) && toRate > 0) {
        return toRate / fromRate;
      }
    }

    if (window.Shopify && Shopify.currency) {
      var shopCode = normalizeCurrencyCode(shopCurrency);
      var activeCode = normalizeCurrencyCode(Shopify.currency.active);
      var shopifyRate = parsePositiveNumber(Shopify.currency.rate, 0);

      if (shopifyRate && from === shopCode && to === activeCode) {
        return shopifyRate;
      }

      if (shopifyRate && from === activeCode && to === shopCode) {
        return 1 / shopifyRate;
      }
    }

    return null;
  }

  function convertShippingAmount(amount, fromCode, toCode) {
    amount = Number(amount || 0);

    if (!shippingRateConversionEnabled) {
      return amount;
    }

    var from = normalizeCurrencyCode(fromCode) || shippingRateSourceCurrency;
    var to = normalizeCurrencyCode(toCode) || activeCurrencyCode();

    if (!from || !to || from === to) {
      return amount;
    }

    var automaticRate = currencyConversionRate(from, to);

    if (Number.isFinite(automaticRate) && automaticRate > 0) {
      return amount * automaticRate;
    }

    return amount * shippingRateManualRate;
  }

  function decimalMoney(amount) {
    amount = Number(amount || 0);
    return amount.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function formatMoneyMajor(amount, currencyCode) {
    amount = Number(amount || 0);

    var code = normalizeCurrencyCode(currencyCode) || activeCurrencyCode(currencyCode);

    if (window.Intl && typeof Intl.NumberFormat === 'function' && code) {
      try {
        if (!currencyFormatters[code]) {
          currencyFormatters[code] = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: code,
            currencyDisplay: 'narrowSymbol'
          });
        }

        return currencyFormatters[code].format(amount);
      } catch (error) {}
    }

    return (code ? code + ' ' : '') + decimalMoney(amount);
  }

  function money(cents, currencyCode) {
    return formatMoneyMajor(Number(cents || 0) / 100, currencyCode);
  }

  function shippingRateMeta(rate) {
    if (!rate) return '';

    var meta = [];

    if (rate.source && String(rate.source).toLowerCase() !== 'shopify') {
      meta.push('Provider: ' + esc(rate.source));
    }

    if (rate.description) {
      meta.push(esc(rate.description));
    }

    if (rate.delivery_date) {
      meta.push('Delivery date: ' + esc(rate.delivery_date));
    } else if (Array.isArray(rate.delivery_range) && rate.delivery_range.length) {
      meta.push('Delivery range: ' + esc(rate.delivery_range.join(' - ')));
    }

    return meta.join(' · ');
  }

  function formatShippingRatePrice(rate) {
    var priceNumber = Number(rate && rate.price);

    if (!Number.isFinite(priceNumber)) {
      return String(rate && rate.price ? rate.price : '');
    }

    var targetCurrency = shippingRateTargetCurrency || activeCurrencyCode();
    var sourceCurrency = normalizeCurrencyCode(rate && rate.currency) || shippingRateSourceCurrency || targetCurrency;
    var convertedPrice = convertShippingAmount(priceNumber, sourceCurrency, targetCurrency);

    return formatMoneyMajor(convertedPrice, targetCurrency);
  }

  // Keyboard and screen reader users: focus moves into the dialog when it opens and
  // back to whatever opened it when it closes. The panel itself takes focus first so
  // the dialog name is announced before its controls.
  var ccdOpener = null;
  function focusIntoDrawer() {
    if (!drawer.classList.contains('is-open')) return;
    var panel = drawer.querySelector('[role="dialog"]');
    if (!panel) return;
    if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
    try { panel.focus(); } catch (error) {}
  }

  // Tab must not leave the dialog, so everything else at body level goes inert while
  // it is open. Only the nodes marked here are released again on close.
  function setOutsideInert(on) {
    if (!('inert' in HTMLElement.prototype)) return;
    var keep = drawer;
    while (keep.parentElement && keep.parentElement !== document.body) keep = keep.parentElement;
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === keep) return;
      if (on) {
        if (el.hasAttribute('inert')) return;
        el.setAttribute('inert', '');
        el.setAttribute('data-ccd-inert', '');
      } else if (el.hasAttribute('data-ccd-inert')) {
        el.removeAttribute('inert');
        el.removeAttribute('data-ccd-inert');
      }
    });
  }

  // Tab and Shift+Tab wrap inside whichever dialog is on top: the request modal, then
  // the high-value modal, then the cart panel. The page outside is already inert, so
  // this only has to turn the caret around at either end of that layer, and pull it
  // back in when it has landed on <body> or on the panel under an open modal.
  var ccdFocusableSelector = 'a[href],button,input,select,textarea,iframe,summary,[tabindex]:not([tabindex="-1"])';

  function ccdCanFocus(el) {
    if (el.matches(':disabled') || el.hidden || el.tabIndex < 0) return false;
    if (el.closest('[aria-hidden="true"], [inert]')) return false;
    if (getComputedStyle(el).visibility === 'hidden') return false;
    if (el.offsetParent === null && getComputedStyle(el).position !== 'fixed') return false;
    return true;
  }

  function ccdActiveLayer() {
    if (requestModal && drawer.classList.contains('is-request-modal-open')) return requestModal;
    if (highValueModalEl && drawer.classList.contains('is-high-value-modal-open')) return highValueModalEl;
    return drawer.querySelector('[role="dialog"]');
  }

  function wrapTabInLayer(e) {
    if (e.defaultPrevented) return;
    var layer = ccdActiveLayer();
    if (!layer) return;
    var stops = Array.prototype.filter.call(layer.querySelectorAll(ccdFocusableSelector), ccdCanFocus);
    if (!stops.length) return;

    var active = document.activeElement;
    var index = stops.indexOf(active);
    var next = null;

    if (!active || !layer.contains(active)) next = stops[0];
    // A wallet's focused shadow control is exposed here as its custom-element host.
    // Let the browser traverse descendants we cannot enumerate, including payment iframes.
    else if (active === layer) next = e.shiftKey ? stops[stops.length - 1] : stops[0];
    else if (e.shiftKey && index === 0) next = stops[stops.length - 1];
    else if (!e.shiftKey && index === stops.length - 1) next = stops[0];
    if (!next) return;

    e.preventDefault();
    try { next.focus(); } catch (error) {}
  }

  function openDrawer(options) {
    options = options || {};

    if (ccdDrawerCloseTimer) {
      clearTimeout(ccdDrawerCloseTimer);
      ccdDrawerCloseTimer = null;
    }
    var wasOpen = drawer.classList.contains('is-open');
    if (!wasOpen) {
      var active = document.activeElement;
      ccdOpener = active && active !== document.body && !drawer.contains(active) ? active : null;
    }
    drawer.classList.remove('is-closing');
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    drawer.inert = false;
    document.body.classList.add('custom-cart-drawer-open');
    if (!wasOpen) setOutsideInert(true);
    // After the accessibility script has lifted inert from the drawer.
    if (!wasOpen) setTimeout(focusIntoDrawer, 60);

    if (options.skipRefresh) {
      return Promise.resolve();
    }

    if (ccdRefreshPromise) {
      return ccdRefreshPromise;
    }

    if (Date.now() - ccdLastRefreshStartedAt < 700) {
      return Promise.resolve();
    }

    return refreshCart();
  }

  function closeDrawer() {
    if (!drawer.classList.contains('is-open')) return;

    if (ccdDrawerCloseTimer) {
      clearTimeout(ccdDrawerCloseTimer);
    }

    // Release the page before focus goes back out, an inert opener cannot take focus.
    setOutsideInert(false);

    var leaving = document.activeElement;
    if (leaving && drawer.contains(leaving)) {
      var back = ccdOpener && document.contains(ccdOpener) && ccdOpener.offsetParent !== null
        ? ccdOpener
        : document.querySelector('.site-header-cart-button, [data-cart-drawer-open]');
      try { if (back) back.focus(); else leaving.blur(); } catch (error) {}
    }
    ccdOpener = null;

    drawer.classList.remove('is-open');
    drawer.classList.add('is-closing');
    drawer.inert = true;

    ccdDrawerCloseTimer = setTimeout(function () {
      drawer.classList.remove('is-closing');
      document.body.classList.remove('custom-cart-drawer-open');
      ccdDrawerCloseTimer = null;
    }, 300);
  }

  function updateCounts(cart) {
    drawer.querySelectorAll('[data-drawer-count]').forEach(function (el) {
      el.textContent = cart.item_count || 0;
    });

    document.querySelectorAll('[data-header-cart-count], .site-header-cart--count, .site-header-cart-count, .cart-count').forEach(function (el) {
      var count = cart.item_count > 0 ? cart.item_count : '';

      el.setAttribute('data-header-cart-count', count);
      el.classList.toggle('visible', !!count);

      if (el.matches('.site-header-cart--count, [data-header-cart-count]')) {
        el.textContent = '';
      } else {
        el.textContent = count;
      }
    });

    document.querySelectorAll('.c_value').forEach(function (el) {
      var msg = el.querySelector('.c_msg');
      if (msg) el.innerHTML = msg.outerHTML + money(cart.total_price);
    });
  }

  function getAvailableStock(item) {
    var raw = variantStockMap[String(item.variant_id)];

    if (raw === null || raw === undefined || raw === '') {
      return null;
    }

    var stock = Number(raw);
    return Number.isFinite(stock) ? stock : null;
  }

  function drawerErrorMessage(error) {
    return (
      (error && error.description) ||
      (error && error.message) ||
      'Unable to update cart quantity. Please refresh and try again.'
    );
  }

  function showDrawerError(message) {
    message = String(message || '');
    var normalizedMessage = message.toLowerCase();

    if (
      message.indexOf('maximum online quantity') !== -1 ||
      message.indexOf('bulk request button below') !== -1 ||
      normalizedMessage.indexOf('due to availability') !== -1 ||
      normalizedMessage.indexOf('available online') !== -1 ||
      normalizedMessage.indexOf('items were added') !== -1
    ) {
      clearDrawerError();
      return;
    }

    if (!errorEl) {
      alert(message);
      return;
    }

    errorEl.textContent = message;
    errorEl.hidden = false;

    clearTimeout(showDrawerError.timer);
    showDrawerError.timer = setTimeout(function () {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }, 4500);
  }

  function clearDrawerError() {
    if (!errorEl) return;
    errorEl.hidden = true;
    errorEl.textContent = '';
  }

  function itemTitle(item) {
    var title = item.product_title || item.title || '';
    if (item.variant_title && item.variant_title !== 'Default Title') title += ' ' + item.variant_title;
    return title;
  }

  function qtyHtml(item) {
    var stock = getAvailableStock(item);
    var currentQty = Number(item.quantity || 1);
    var label = ' aria-label="Quantity, ' + esc(itemTitle(item)) + '"';

    var hasTenPlus = stock === null || stock >= 10 || currentQty >= 10;
    var maxSelect = stock !== null && stock < 10 ? Math.max(1, stock) : 9;
    var html = '<div class="ccd__qty-wrap" data-qty-wrap data-line-key="' + item.key + '" data-current-qty="' + currentQty + '" data-variant-id="' + item.variant_id + '">';

    if (currentQty >= 10 && hasTenPlus) {
      html += '<input class="ccd__qty ccd__qty-input" data-qty-input type="number" inputmode="numeric" min="1" value="' + currentQty + '"' + label + '>';
      html += '</div>';
      return html;
    }

    html += '<select class="ccd__qty ccd__qty-select" data-qty-select' + label + '>';

    for (var i = 1; i <= maxSelect; i++) {
      html += '<option value="' + i + '"' + (i === currentQty ? ' selected' : '') + '>' + i + '</option>';
    }

    if (hasTenPlus) {
      html += '<option value="10plus">10+</option>';
    }

    html += '</select></div>';

    return html;
  }

  function esc(str) {
    return String(str || '').replace(/[&<>"']/g, function (s) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'})[s];
    });
  }

  function cartItemText(item) {
    return [
      item && item.product_title,
      item && item.title,
      item && item.variant_title,
      item && item.handle,
      item && item.url,
      item && item.product_type,
      item && item.vendor
    ].join(' ').toLowerCase();
  }

  function cartContainsProductHandle(cart, handle) {
    handle = String(handle || '').trim();
    if (!handle || !cart || !Array.isArray(cart.items)) return false;

    return cart.items.some(function (item) {
      var itemHandle = String(item.handle || '').trim();
      var itemUrl = String(item.url || '');

      return itemHandle === handle || itemUrl.indexOf('/products/' + handle) !== -1;
    });
  }

  function renderClientSideConditionalUpsells(cart) {
    if (!upsellsEl || !cart || !Array.isArray(cart.items)) return;

    var templates = immediateUpsellTemplates || {};
    var pieces = [];
    var hasSata = false;
    var hasU2 = false;

    cart.items.forEach(function (item) {
      var text = cartItemText(item);

      if (text.indexOf('sata') !== -1 || text.indexOf('interface:sata') !== -1) {
        hasSata = true;
      }

      if (text.indexOf('u.2') !== -1 || text.indexOf('u-2') !== -1 || text.indexOf('u 2') !== -1) {
        hasU2 = true;
      }
    });

    if (templates.oldCartConditionalEnabled) {
      if (hasSata && templates.sata && !cartContainsProductHandle(cart, templates.sataHandle)) {
        pieces.push(templates.sata);
      }

      if (hasU2 && templates.u2 && !cartContainsProductHandle(cart, templates.u2Handle)) {
        pieces.push(templates.u2);
      }
    }

    if (!pieces.length && templates.manualFallbackEnabled && templates.manual && !cartContainsProductHandle(cart, templates.manualHandle)) {
      pieces.push(templates.manual);
    }

    upsellsEl.innerHTML = pieces.join('');
    upsellsEl.dataset.ccdImmediate = pieces.length ? 'true' : 'false';
  }

  function setHighValueCheckoutState(isBlocked, isChecking) {
    isBlocked = !!isBlocked;
    isChecking = !!isChecking;

    drawer.classList.toggle('is-high-value-cart', isBlocked);
    drawer.classList.toggle('is-checking-high-value-cart', isChecking);

    if (checkoutFormEl) {
      checkoutFormEl.dataset.ccdCheckoutReady = isChecking ? 'false' : 'true';
      checkoutFormEl.dataset.ccdCheckoutBlocked = isBlocked ? 'true' : 'false';
      checkoutFormEl.dataset.ccdCheckoutChecking = isChecking ? 'true' : 'false';
      checkoutFormEl.setAttribute('aria-busy', isChecking ? 'true' : 'false');
    }

    if (checkoutButtonEl) {
      if (isChecking) {
        // A pending quantity/cart update must not be clickable or submit the form.
        checkoutButtonEl.disabled = true;
        checkoutButtonEl.type = 'button';
        checkoutButtonEl.setAttribute('aria-disabled', 'true');
      } else if (isBlocked) {
        // Keep a confirmed high-value button clickable so it can open the sales modal.
        checkoutButtonEl.disabled = false;
        checkoutButtonEl.type = 'button';
        checkoutButtonEl.setAttribute('aria-disabled', 'true');
      } else {
        checkoutButtonEl.disabled = false;
        checkoutButtonEl.type = 'submit';
        checkoutButtonEl.setAttribute('aria-disabled', 'false');
      }
    }

    if (acceleratedButtonsEl) {
      acceleratedButtonsEl.hidden = isBlocked || isChecking;
    }

    if (highValueMessageEl) {
      highValueMessageEl.hidden = !isBlocked || isChecking;
    }
  }

  function openHighValueCheckoutModal() {
    if (!highValueModalEl) return;

    highValueModalLastFocus = document.activeElement;
    highValueModalEl.hidden = false;
    highValueModalEl.classList.remove('is-closing');
    drawer.classList.add('is-high-value-modal-open');
    document.body.classList.add('custom-cart-drawer-open');

    setTimeout(function () {
      var focusTarget = highValueModalEl.querySelector('[data-ccd-high-value-contact], [data-ccd-high-value-modal-close]');
      try { if (focusTarget) focusTarget.focus(); } catch (ignore) {}
    }, 0);
  }

  function closeHighValueCheckoutModal() {
    if (!highValueModalEl || highValueModalEl.hidden) return;

    highValueModalEl.hidden = true;
    highValueModalEl.classList.remove('is-closing');
    drawer.classList.remove('is-high-value-modal-open');

    if (!drawer.classList.contains('is-open')) {
      document.body.classList.remove('custom-cart-drawer-open');
    }

    try { if (highValueModalLastFocus && highValueModalLastFocus.focus) highValueModalLastFocus.focus(); } catch (ignore) {}
    highValueModalLastFocus = null;
  }

  function highValueThresholdCentsForCart(cart) {
    var cartCurrency = currencyFromCart(cart) || activeCurrencyCode();
    var conversionRate = currencyConversionRate(highValueCheckoutThresholdCurrency, cartCurrency);

    if (!conversionRate || !Number.isFinite(conversionRate) || conversionRate <= 0) {
      return null;
    }

    return Math.round(highValueCheckoutThresholdMajor * conversionRate * 100);
  }

  function updateHighValueCheckout(cart) {
    if (!highValueCheckoutOnlyEnabled || !cart) {
      setHighValueCheckoutState(false, false);
      return;
    }

    var totalPrice = Number(cart.total_price || 0);
    var convertedThresholdCents = highValueThresholdCentsForCart(cart);

    if (convertedThresholdCents !== null) {
      var convertedThresholdCurrency = currencyFromCart(cart) || activeCurrencyCode();

      if (window.CCDUpdateHighValueMessage) {
        window.CCDUpdateHighValueMessage(drawer, convertedThresholdCents, convertedThresholdCurrency);
      }

      setHighValueCheckoutState(totalPrice > convertedThresholdCents, false);
      return;
    }

    if (!highValueCurrencyRatesRequested) {
      highValueCurrencyRatesRequested = true;
      setHighValueCheckoutState(false, true);

      ensureCurrencyConverter(true).then(function () {
        highValueCurrencyRatesResolved = true;
        if (lastCart) updateHighValueCheckout(lastCart);
      });
      return;
    }

    if (!highValueCurrencyRatesResolved) {
      setHighValueCheckoutState(false, true);
      return;
    }

    // Do not permanently lock normal carts if a rare/unsupported currency has no rate.
    // The drawer logs the condition and fails open; server-side validation is required
    // for non-bypassable enforcement across every possible checkout entry point.
    console.warn(
      'Cart drawer could not convert the high-value threshold from',
      highValueCheckoutThresholdCurrency,
      'to',
      currencyFromCart(cart) || activeCurrencyCode()
    );
    setHighValueCheckoutState(false, false);
  }


  function lineStockMessageContentHtml(lineKey, message) {
    message = String(message || '');

    if (!message) return '';

    var match = message.match(/^Only\s+(\d+)\s+items?\s+available online\.\s+Need more\?$/i);

    if (!match) {
      return esc(message);
    }

    var availableQty = Number(match[1] || 0);
    var noun = availableQty === 1 ? 'item' : 'items';

    return 'Only ' + esc(availableQty) + ' ' + noun + ' available online. ' +
      '<button type="button" class="ccd__line-bulk-link" data-ccd-open-request data-ccd-request-tab="bulk" data-ccd-request-intent="bulk_line" data-ccd-request-line-key="' + esc(lineKey) + '">Need more?</button>';
  }

  function lineMessageHtml(item) {
    var key = item && item.key ? item.key : '';
    var message = key && ccdLineMessages[key] ? ccdLineMessages[key] : '';

    return '<div class="ccd__line-message' + (message ? ' is-visible' : '') + '" data-line-stock-message="' + esc(key) + '">' + lineStockMessageContentHtml(key, message) + '</div>';
  }

  function setLineStockMessage(lineKey, message) {
    if (!lineKey) return;

    ccdLineMessages[lineKey] = message || '';

    var target = findLineStockMessageEl(lineKey);
    if (!target) return;

    target.innerHTML = lineStockMessageContentHtml(lineKey, message || '');
    target.classList.toggle('is-visible', !!message);
  }

  function clearLineStockMessage(lineKey) {
    if (!lineKey) return;
    delete ccdLineMessages[lineKey];

    var target = findLineStockMessageEl(lineKey);
    if (!target) return;

    target.textContent = '';
    target.classList.remove('is-visible');
  }

  function findLineStockMessageEl(lineKey) {
    var nodes = drawer.querySelectorAll('[data-line-stock-message]');

    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-line-stock-message') === String(lineKey || '')) {
        return nodes[i];
      }
    }

    return null;
  }

  function lineStockLimitMessage(availableQty) {
    availableQty = Math.max(1, Math.floor(Number(availableQty || 1)));

    return 'Only ' + availableQty + ' item' + (availableQty === 1 ? '' : 's') +
      ' available online. Need more?';
  }

  function cartItemByLineKey(cart, lineKey) {
    if (!cart || !Array.isArray(cart.items)) return null;

    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].key || '') === String(lineKey || '')) {
        return cart.items[i];
      }
    }

    return null;
  }

  function syncLineLimitMessageFromCart(lineKey, requestedQty, cart) {
    var item = cartItemByLineKey(cart, lineKey);
    var finalQty = item ? Number(item.quantity || 0) : 0;
    requestedQty = Number(requestedQty || 0);

    if (Number.isFinite(requestedQty) && Number.isFinite(finalQty) && finalQty > 0 && requestedQty > finalQty) {
      setLineStockMessage(lineKey, lineStockLimitMessage(finalQty));
      return true;
    }

    clearLineStockMessage(lineKey);
    return false;
  }

  function availabilityQtyFromMessage(message) {
    message = String(message || '');

    var match = message.match(/Only\s+(\d+)\s+items?\s+(?:were\s+added|available)/i);
    if (match && match[1]) {
      return Number(match[1]);
    }

    return null;
  }


  function bulkCtaHtml(item, index) {
    var openId = 'i' + (Number(index || 0) + 1);
    var title = item && (item.product_title || item.title) ? (item.product_title || item.title) : 'this product';

    return [
      '<button type="button" class="bulkcta" data-open="' + esc(openId) + '" data-ccd-open-request data-ccd-request-tab="bulk" data-ccd-request-intent="bulk_line" data-ccd-request-line-key="' + esc(item && item.key ? item.key : '') + '">',
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">',
          '<path d="M12 2 2 7l10 5 10-5-10-5z"></path>',
          '<path d="M2 17l10 5 10-5M2 12l10 5 10-5"></path>',
        '</svg>',
        'I need more than is available online',
        // The product goes after the visible text as hidden text, so the name starts with what is shown.
        '<span class="spd-sr-only" style="position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap"> for ' + esc(title) + '</span>',
      '</button>'
    ].join('');
  }

  function render(cart, options) {
    lastCart = cart;
    options = options || {};
    syncCartCurrency(cart);
    updateCounts(cart);
    subtotalEl.textContent = money(cart.total_price);
    updateHighValueCheckout(cart);
    if (noteEl) noteEl.value = cart.note || '';

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '';
      if (upsellsEl) upsellsEl.innerHTML = '';
      emptyEl.hidden = false;
      if (globalWarnEl) globalWarnEl.hidden = true;
      return;
    }

    emptyEl.hidden = true;
    if (globalWarnEl) globalWarnEl.hidden = false;

    itemsEl.innerHTML = cart.items.map(function (item, index) {
      var title = itemTitle(item);

      var image = item.image
        ? '<img src="' + item.image + '" alt="' + esc(title) + '">'
        : '<div></div>';

      return [
        '<div class="ccd__item">',
          '<a href="' + item.url + '">' + image + '</a>',
          '<div>',
            '<a class="ccd__item-title" href="' + item.url + '">' + esc(title) + '</a>',
            '<div class="ccd__price">' + money(item.final_price) + '</div>',
            '<div>' + qtyHtml(item) + lowStockBadge(item) + '</div>',
            bulkCtaHtml(item, index),
            lineMessageHtml(item),
          '</div>',
          '<button type="button" class="ccd__remove" data-remove-key="' + item.key + '" aria-label="Remove ' + esc(title) + '">×</button>',
        '</div>'
      ].join('');
    }).join('');

    if (!options.preserveUpsells) {
      renderClientSideConditionalUpsells(cart);
    }
  }

  function setCartUiLocked(locked, activeWrap) {
    if (locked) {
      ccdCartUiLockDepth += 1;
    } else {
      ccdCartUiLockDepth = Math.max(0, ccdCartUiLockDepth - 1);
    }

    var isLocked = ccdCartUiLockDepth > 0;
    drawer.classList.toggle('is-cart-ui-locked', isLocked);

    if (loadingEl) {
      loadingEl.hidden = true;
    }

    drawer.querySelectorAll('[data-qty-input], [data-qty-select]').forEach(function (field) {
      if (!field) return;

      var fieldWrap = field.closest('[data-qty-wrap]');
      var isActiveField = activeWrap && fieldWrap === activeWrap;

      if (isLocked && !isActiveField) {
        if (!field.hasAttribute('data-ccd-lock-prev-disabled')) {
          field.setAttribute('data-ccd-lock-prev-disabled', field.disabled ? 'true' : 'false');
        }
        field.disabled = true;
        field.setAttribute('aria-disabled', 'true');
      } else if (!isLocked) {
        if (field.getAttribute('data-ccd-lock-prev-disabled') === 'false') {
          field.disabled = false;
        }
        field.removeAttribute('aria-disabled');
        field.removeAttribute('data-ccd-lock-prev-disabled');
        field.classList.remove('is-updating-field');
      }

      field.classList.toggle('is-updating-field', !!(isLocked && isActiveField));
    });
  }

  function markCheckoutPending() {
    if (highValueCheckoutOnlyEnabled) {
      setHighValueCheckoutState(false, true);
    }
  }

  function clearQtyCommitTimer(wrap) {
    if (!wrap) return;

    var timer = ccdQtyCommitTimers ? ccdQtyCommitTimers.get(wrap) : wrap._ccdQtyCommitTimer;
    if (timer) clearTimeout(timer);

    if (ccdQtyCommitTimers) ccdQtyCommitTimers.delete(wrap);
    else wrap._ccdQtyCommitTimer = null;
  }

  function scheduleQtyCommit(control, delay) {
    var wrap = control && control.closest ? control.closest('[data-qty-wrap]') : null;
    if (!wrap) return;

    markCheckoutPending();
    clearQtyCommitTimer(wrap);

    var timer = setTimeout(function () {
      clearQtyCommitTimer(wrap);
      if (!drawer.contains(control)) return;
      updateQuantityFromControl(control, control.value);
    }, Number(delay || 700));

    if (ccdQtyCommitTimers) ccdQtyCommitTimers.set(wrap, timer);
    else wrap._ccdQtyCommitTimer = timer;
  }

  function restoreCheckoutFromConfirmedCart() {
    if (highValueCheckoutOnlyEnabled && !ccdCartActionInProgress && lastCart) {
      updateHighValueCheckout(lastCart);
    }
  }

  function beginCartUpdateLock(activeWrap) {
    markCheckoutPending();
    setCartUiLocked(true, activeWrap || null);
  }

  function endCartUpdateLock() {
    setCartUiLocked(false, null);
  }

  function refreshCart(options) {
    options = options || {};

    if (ccdRefreshPromise) {
      return ccdRefreshPromise;
    }

    ccdLastRefreshStartedAt = Date.now();
    if (!options.silent && loadingEl && !ccdCartActionInProgress) {
      loadingEl.hidden = false;
    }

    ccdRefreshPromise = fetch(root + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);

        return fetchStockMap(cart).then(function () {
          render(cart, { preserveUpsells: true });
          return cart;
        });
      })
      .finally(function () {
        if (loadingEl) {
          loadingEl.hidden = true;
        }
        ccdRefreshPromise = null;
      });

    return ccdRefreshPromise;
  }

  function changeLine(key, quantity, options) {
    options = options || {};

    markCheckoutPending();
    drawer.classList.add('is-updating');
    clearDrawerError();
    ccdCartActionInProgress = true;
    ccdLastInternalCartActionAt = Date.now();

    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: Number(quantity) })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status >= 300 || !Array.isArray(data.items)) {
            throw data;
          }

          return data;
        });
      })
      .then(function (cart) {
        render(cart, { preserveUpsells: true });

        if (options.originalRequestedQty !== undefined && Number(options.originalRequestedQty) > 0) {
          syncLineLimitMessageFromCart(key, options.originalRequestedQty, cart);
        } else if (options.lineErrorMessage) {
          setLineStockMessage(key, options.lineErrorMessage);
        }

        return cart;
      })
      .catch(function (error) {
        if (options.suppressGlobalError) {
          clearDrawerError();

          var parsedQty = availabilityQtyFromMessage(drawerErrorMessage(error));
          if (parsedQty && parsedQty > 0) {
            setLineStockMessage(key, lineStockLimitMessage(parsedQty));
          } else {
            setLineStockMessage(
              key,
              options.lineErrorMessage || drawerErrorMessage(error) || 'Unable to update this item. Please try again.'
            );
          }

          return refreshCart({ silent: true }).then(function (cart) {
            if (options.originalRequestedQty !== undefined && Number(options.originalRequestedQty) > 0) {
              syncLineLimitMessageFromCart(key, options.originalRequestedQty, cart);
            }
            return cart;
          });
        }

        showDrawerError(drawerErrorMessage(error));
        return refreshCart({ silent: true });
      })
      .finally(function () {
        drawer.classList.remove('is-updating');
        ccdLastInternalCartActionAt = Date.now();
        ccdCartActionInProgress = false;
      });
  }


  function addVariant(variantId) {
    markCheckoutPending();
    drawer.classList.add('is-updating');
    clearDrawerError();
    ccdCartActionInProgress = true;
    ccdLastInternalCartActionAt = Date.now();

    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status >= 300) {
            throw data;
          }
          return data;
        });
      })
      .then(refreshCart)
      .catch(function (error) {
        showDrawerError(drawerErrorMessage(error));
        return refreshCart();
      })
      .finally(function () {
        drawer.classList.remove('is-updating');
        ccdLastInternalCartActionAt = Date.now();
        ccdCartActionInProgress = false;
      });
  }


  // Boost AI leftover, Boost is off: AJAX add-to-cart for Boost grid buttons.
  //  function parseBoostAddToCartVariantId(button) {
  //    if (!button) return null;
  //
  //    var directVariantId =
  //      button.getAttribute('data-variant-id') ||
  //      button.dataset.variantId ||
  //      null;
  //
  //    if (directVariantId) {
  //      return directVariantId;
  //    }
  //
  //    var raw = button.getAttribute('data-metadata');
  //    if (!raw) return null;
  //
  //    try {
  //      var data = JSON.parse(raw);
  //      var addToCart = data && data.action && data.action.addToCart ? data.action.addToCart : null;
  //
  //      if (addToCart && addToCart.productId) {
  //        return addToCart.productId;
  //      }
  //    } catch (error) {
  //      console.warn('Boost add-to-cart metadata parse failed:', error);
  //    }
  //
  //    return null;
  //  }
  //
  //  function handleBoostAddToCartClick(event) {
  //    // Cheap early bail: only run the closest() check if the click might be on a Boost button.
  //    var target = event.target;
  //    if (!target || !target.closest) return;
  //
  //    var boostButton = target.closest(
  //      '.boost-sd__button[data-metadata], .boost-sd__button--select-option[data-metadata], .boost-sd__cta-button button[data-metadata], .boost-sd__btn-add-to-cart[data-variant-id], .boost-sd__button[data-variant-id]'
  //    );
  //
  //    if (!boostButton) return;
  //
  //    var variantId = parseBoostAddToCartVariantId(boostButton);
  //    if (!variantId) return;
  //
  //    event.preventDefault();
  //    event.stopPropagation();
  //    if (typeof event.stopImmediatePropagation === 'function') {
  //      event.stopImmediatePropagation();
  //    }
  //
  //    if (boostButton.dataset.ccdAdding === 'true') return;
  //    boostButton.dataset.ccdAdding = 'true';
  //
  //    boostButton.classList.add('is-loading');
  //    boostButton.setAttribute('aria-busy', 'true');
  //
  //    var sellingPlan = boostButton.getAttribute('data-selling-plan') || '';
  //
  //    if (!sellingPlan) {
  //      try {
  //        var metadata = JSON.parse(boostButton.getAttribute('data-metadata') || '{}');
  //        sellingPlan = metadata && metadata.action && metadata.action.addToCart
  //          ? metadata.action.addToCart.selling_plan
  //          : '';
  //      } catch (error) {}
  //    }
  //
  //    var payload = {
  //      id: Number(variantId),
  //      quantity: 1
  //    };
  //
  //    if (sellingPlan) {
  //      payload.selling_plan = sellingPlan;
  //    }
  //
  //    fetch(root + 'cart/add.js', {
  //      method: 'POST',
  //      headers: {
  //        'Content-Type': 'application/json',
  //        Accept: 'application/json'
  //      },
  //      body: JSON.stringify(payload)
  //    })
  //      .then(function (response) {
  //        return response.json().then(function (data) {
  //          if (!response.ok || data.status >= 300) {
  //            throw data;
  //          }
  //          return data;
  //        });
  //      })
  //      .then(function () {
  //        return openDrawer();
  //      })
  //      .catch(function (error) {
  //        console.error('Boost AJAX add-to-cart failed:', error);
  //        alert(error && error.description ? error.description : 'Unable to add item to cart.');
  //      })
  //      .finally(function () {
  //        boostButton.dataset.ccdAdding = 'false';
  //        boostButton.classList.remove('is-loading');
  //        boostButton.removeAttribute('aria-busy');
  //      });
  //  }
  //
  //  document.addEventListener('click', handleBoostAddToCartClick, true);


  function setRemoveLoading(removeButton, isLoading) {
    if (!removeButton) return;

    var item = removeButton.closest('.ccd__item');

    if (item) {
      item.classList.toggle('is-removing', isLoading);
    }

    removeButton.classList.toggle('is-loading', isLoading);
    removeButton.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    removeButton.disabled = !!isLoading;

    if (isLoading) {
      removeButton.dataset.originalLabel = removeButton.innerHTML;
      removeButton.innerHTML = '×';
      drawer.classList.add('is-updating');
    } else {
      if (removeButton.dataset.originalLabel) {
        removeButton.innerHTML = removeButton.dataset.originalLabel;
      }
      drawer.classList.remove('is-updating');
    }
  }



  function requestStatus(message, isError) {
    if (!requestStatusEl) return;

    var isSuccess = !isError && String(message || '').toLowerCase().indexOf('submitted') !== -1;

    requestStatusEl.hidden = false;
    requestStatusEl.textContent = message;
    requestStatusEl.classList.toggle('is-error', !!isError);
    requestStatusEl.classList.toggle('is-success', !!isSuccess);

    if (requestModal) {
      requestModal.classList.toggle('is-request-success-view', !!isSuccess);
    }
  }

  // Validators land focus on the bad field. Tie the status message to it so the screen
  // reader says why, and drop the marks as soon as the customer edits that field.
  function focusInvalidRequestField(field) {
    if (!field) return;
    if (requestStatusEl) {
      if (!requestStatusEl.id) requestStatusEl.id = cfg.drawerId + '-request-status';
      field.setAttribute('aria-describedby', requestStatusEl.id);
    }
    if (field.getAttribute('aria-invalid') !== 'true') {
      field.setAttribute('aria-invalid', 'true');
      field.addEventListener('input', function clear() {
        field.removeAttribute('aria-invalid');
        field.removeAttribute('aria-describedby');
        field.removeEventListener('input', clear);
      });
    }
    field.focus();
  }

  function clearRequestStatus() {
    if (requestModal) {
      requestModal.classList.remove('is-direct-hulk-success');
        requestModal.classList.remove('is-request-success-view');
      requestModal.classList.remove('is-request-success-view');
    }

    if (!requestStatusEl) return;

    requestStatusEl.hidden = true;
    requestStatusEl.textContent = '';
    requestStatusEl.classList.remove('is-error');
    requestStatusEl.classList.remove('is-success');
  }

  function requestField(name) {
    return drawer.querySelector('[data-ccd-request-field="' + name + '"]');
  }

  function cleanRequestText(value) {
    return String(value == null ? '' : value)
      .replace(/[\u200B-\u200D\uFEFF]/g, '')
      .replace(/[\r\n\t]+/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function requestFieldValue(name) {
    var field = requestField(name);
    return field ? cleanRequestText(field.value) : '';
  }

  function requestLetterCount(value) {
    value = String(value || '');

    try {
      return (value.match(new RegExp('\\p{L}', 'gu')) || []).length;
    } catch (error) {
      return (value.match(/[A-Za-zÀ-ÖØ-öø-ÿ]/g) || []).length;
    }
  }

  function requestNameIsValid(value) {
    value = cleanRequestText(value);
    return value.length >= 2 && requestLetterCount(value) >= 2;
  }

  function requestCompanyIsValid(value) {
    value = cleanRequestText(value);
    return value.length >= 2 && requestLetterCount(value) >= 1;
  }

  function requestEmailIsValid(value) {
    value = cleanRequestText(value).toLowerCase();
    if (value.length < 6 || value.length > 160) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  function strictRequestQuantity(value) {
    var raw = String(value == null ? '' : value).trim();
    if (!raw) return 0;

    var cleaned = raw.replace(/[\s,]/g, '');
    if (!/^\d+$/.test(cleaned)) return 0;

    var number = Number(cleaned);
    if (!Number.isSafeInteger(number) || number < 1 || number > 999999) return 0;
    return number;
  }

  function normalizeRequestTab(tab) {
    tab = String(tab || '').toLowerCase();
    if (tab === 'sell') return 'sell';
    if (tab === 'proc' || tab === 'procurement') return 'proc';
    return 'bulk';
  }

  function updateRequestSubmitText() {
    var submit = drawer.querySelector('[data-ccd-request-submit]');
    if (!submit) return;

    if (requestActiveTab === 'sell') {
      submit.textContent = 'Send Sell Request';
    } else if (requestActiveTab === 'proc') {
      submit.textContent = 'Send Procurement Request';
    } else {
      submit.textContent = 'Send Bulk Request';
    }
  }


  function resetDirectHulkFormForOpen(type) {
    type = normalizeRequestTab(type);
    if (type !== 'proc' && type !== 'sell') return;

    var host = hulkHost(type);
    if (!host) return;

    // Do not force-reload Hulk iframes here. Reloading the iframe on every
    // tab open caused visible delays and repeated refresh/blank states.
    // Just clear our local success state and let Hulk keep its rendered form.
    host.classList.remove('is-hulk-submitted');
    host.dataset.ccdDirectOpenedAt = String(Date.now());
    host.dataset.ccdDirectInteracted = 'false';
    host.dataset.ccdDirectInteractedAt = '0';
    host.dataset.ccdResetting = 'false';

    host.querySelectorAll('.pxFormGenerator, iframe').forEach(function (el) {
      el.style.display = '';
      el.style.visibility = '';
      el.style.opacity = '';
    });

    setTimeout(function () {
      primeDirectHulkConfirmation(type);
    }, 300);
  }

  function setRequestTab(tab) {
    requestActiveTab = normalizeRequestTab(tab);

    if (requestModal) {
      requestModal.classList.remove('is-direct-hulk-success');
        requestModal.classList.remove('is-request-success-view');
    }

    if (requestActiveTab === 'proc' || requestActiveTab === 'sell') {
      resetDirectHulkFormForOpen(requestActiveTab);
    }

    drawer.querySelectorAll('[data-ccd-request-tab-button]').forEach(function (button) {
      var isActive = button.getAttribute('data-ccd-request-tab-button') === requestActiveTab;
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    drawer.querySelectorAll('[data-ccd-request-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-ccd-request-panel') !== requestActiveTab;
    });

    var useCustomBulkForm = requestActiveTab === 'bulk';

    drawer.querySelectorAll('[data-ccd-custom-request-fields], [data-ccd-custom-request-foot]').forEach(function (block) {
      block.hidden = !useCustomBulkForm;
    });

    updateRequestSubmitText();

    if (requestBodyEl) {
      requestBodyEl.scrollTop = 0;
    }

    if (requestActiveTab === 'proc' || requestActiveTab === 'sell') {
      setTimeout(function () {
        primeDirectHulkConfirmation(requestActiveTab);
      }, 450);
    }
  }

  function requestFallbackThumb() {
    return '<svg viewBox="0 0 48 48" fill="none" aria-hidden="true"><rect x="6" y="10" width="36" height="28" rx="3" fill="currentColor" opacity=".22"/><rect x="9" y="13" width="30" height="16" rx="2" fill="currentColor" opacity=".16"/><circle cx="11" cy="34" r="1.4" fill="currentColor"/><circle cx="24" cy="34" r="1.4" fill="currentColor"/><circle cx="37" cy="34" r="1.4" fill="currentColor"/></svg>';
  }

  function cartItemFullUrl(item) {
    var url = item && item.url ? String(item.url) : '';
    if (!url) return window.location.href;
    if (/^https?:\/\//i.test(url)) return url;
    return window.location.origin + url;
  }

  function availableTextForItem(item) {
    var stock = getAvailableStock(item);

    if (stock === null || stock === undefined || !Number.isFinite(Number(stock))) {
      return 'Contact us';
    }

    return String(stock);
  }


  function findRequestLine(lineKey, openId) {
    lineKey = String(lineKey || '');
    openId = String(openId || '');

    var rows = drawer.querySelectorAll('[data-ccd-request-cart-line]');

    for (var i = 0; i < rows.length; i++) {
      if (lineKey && rows[i].getAttribute('data-line-key') === lineKey) {
        return rows[i];
      }
    }

    for (var j = 0; j < rows.length; j++) {
      if (openId && rows[j].getAttribute('data-open') === openId) {
        return rows[j];
      }
    }

    return null;
  }

  function renderRequestCartLines(cart) {
    if (!requestCartLinesEl) return;

    cart = cart || lastCart || { items: [] };

    if (!cart.items || !cart.items.length) {
      requestCartLinesEl.innerHTML = '<div class="ccd__request-cart-empty">Your cart is empty. Add items to request bulk pricing, or use the Procurement tab for parts we do not stock.</div>';
      return;
    }

    requestCartLinesEl.innerHTML = cart.items.map(function (item, index) {
      var title = item.product_title || item.title || '';
      if (item.variant_title && item.variant_title !== 'Default Title') title += ' ' + item.variant_title;
      var sku = item.sku || 'N/A';
      var image = item.image
        ? '<img src="' + esc(item.image) + '" alt="' + esc(title) + '">'
        : requestFallbackThumb();

      return [
        '<div class="ccd__request-qrow" data-ccd-request-cart-line data-index="' + index + '" data-open="i' + (index + 1) + '" data-line-key="' + esc(item.key || '') + '" data-title="' + esc(title) + '" data-sku="' + esc(sku) + '" data-url="' + esc(cartItemFullUrl(item)) + '" data-variant-id="' + esc(item.variant_id) + '" data-cart-qty="' + esc(item.quantity) + '" data-available="' + esc(availableTextForItem(item)) + '">',
          '<div class="ccd__request-thumb">' + image + '</div>',
          '<div>',
            '<p class="ccd__request-title">' + esc(title) + '</p>',
            '<p class="ccd__request-meta">Available now: ' + esc(availableTextForItem(item)) + '</p>',
          '</div>',
          '<div class="ccd__request-need">',
            '<label>Qty needed</label>',
            '<input data-ccd-need-input type="text" inputmode="numeric" autocomplete="off" maxlength="9" aria-label="Quantity needed" placeholder="e.g. 2,000">',
          '</div>',
          '<div class="ccd__request-hint" data-ccd-need-hint hidden></div>',
        '</div>'
      ].join('');
    }).join('');
  }

  function addProcurementRow(mpn, qty, description) {
    if (!procurementListEl) return;

    var row = document.createElement('div');
    row.className = 'ccd__request-procrow';
    row.setAttribute('data-ccd-procurement-row', '');
    row.innerHTML = [
      '<input class="ccd__request-input" data-ccd-proc-mpn aria-label="Manufacturer part number" placeholder="Manufacturer part # / MPN">',
      '<input class="ccd__request-input" data-ccd-proc-qty inputmode="numeric" aria-label="Quantity" placeholder="Qty">',
      '<button class="ccd__request-remove" type="button" data-ccd-remove-procurement aria-label="Remove part">×</button>',
      '<input class="ccd__request-input ccd__request-input--full" data-ccd-proc-desc aria-label="Description" placeholder="Description (capacity, condition, form factor…)">'
    ].join('');

    procurementListEl.appendChild(row);

    row.querySelector('[data-ccd-proc-mpn]').value = mpn || '';
    row.querySelector('[data-ccd-proc-qty]').value = qty || '';
    row.querySelector('[data-ccd-proc-desc]').value = description || '';
  }

  function ensureProcurementRow() {
    if (procurementListEl && !procurementListEl.querySelector('[data-ccd-procurement-row]')) {
      addProcurementRow('', '', '');
    }
  }

  function setFileLabel(type, files) {
    var label = drawer.querySelector('[data-ccd-file-label="' + type + '"]');
    if (!label) return;

    if (!files || !files.length) {
      label.innerHTML = 'or <em>browse</em> · .xlsx, .xls, .csv';
      return;
    }

    var names = Array.prototype.slice.call(files).map(function (file) { return file.name; });
    label.textContent = names.join(', ');
  }

  function requestIntentForTab(tab) {
    tab = normalizeRequestTab(tab);
    if (tab === 'sell') return 'sell';
    if (tab === 'proc') return 'procurement';
    return 'bulk';
  }

  var hulkMounted = false;
  function ccdMountHulkForms() {
    if (hulkMounted) return;
    hulkMounted = true;
    document.querySelectorAll('template[data-ccd-hulk-tpl]').forEach(function (t) {
      t.replaceWith(t.content.cloneNode(true));
    });
    var assets = (window.hulkFormBuilder && window.hulkFormBuilder.assets) || {};
    function css(href) { if (!href) return; var l = document.createElement('link'); l.rel = 'stylesheet'; l.href = href; document.head.appendChild(l); }
    function js(src, next) { if (!src) { next(); return; } var s = document.createElement('script'); s.src = src; s.onload = next; s.onerror = next; document.body.appendChild(s); }
    function boot() {
      if (typeof window.GetCorePage === 'function') window.GetCorePage();
      if (typeof window.hulkFBInitFormBuilder === 'function') window.hulkFBInitFormBuilder();
      if (typeof window.hulkFBKeyboardAccess === 'function') window.hulkFBKeyboardAccess();
    }
    if (typeof window.RenderFormById === 'function') { boot(); return; }
    css(assets.extraStyles); css(assets.bootstrapStyles); css(assets.formLayoutStyles);
    js(assets.searchableDropdown, function () { js(assets.extraFunctions, boot); });
  }
  window.ccdMountHulkForms = ccdMountHulkForms;

  var requestOpener = null;
  function openRequestModal(tab, intent, lineKey, openId) {
    if (!requestModal) return;
    if (!drawer.classList.contains('is-request-modal-open')) requestOpener = document.activeElement;
    ccdMountHulkForms();

    var nextTab = normalizeRequestTab(tab);
    var targetLineKey = String(lineKey || '');
    var targetOpenId = String(openId || '');
    requestIntent = intent || requestIntentForTab(nextTab);
    setRequestTab(nextTab);
    clearRequestStatus();
    renderRequestCartLines(lastCart);
    ensureProcurementRow();

    if (ccdRequestCloseTimer) {
      clearTimeout(ccdRequestCloseTimer);
      ccdRequestCloseTimer = null;
    }
    requestModal.classList.remove('is-closing');
    requestModal.hidden = false;
    drawer.classList.add('is-request-modal-open');

    if (requestBodyEl) {
      requestBodyEl.scrollTop = 0;
    }

    setTimeout(function () {
      var first;
      var targetRow = null;

      drawer.querySelectorAll('[data-ccd-request-cart-line].is-targeted').forEach(function (row) {
        row.classList.remove('is-targeted');
      });

      if (requestActiveTab === 'sell') {
        first = drawer.querySelector('[data-ccd-hulk-form="sell"] iframe') || drawer.querySelector('[data-ccd-hulk-form="sell"]');
      } else if (requestActiveTab === 'proc') {
        first = drawer.querySelector('[data-ccd-hulk-form="proc"] iframe') || drawer.querySelector('[data-ccd-hulk-form="proc"]');
      } else {
        targetRow = findRequestLine(targetLineKey, targetOpenId);

        if (targetRow) {
          targetRow.classList.add('is-targeted');
          first = targetRow.querySelector('[data-ccd-need-input]');

          try {
            targetRow.scrollIntoView({ block: 'center', behavior: 'smooth' });
          } catch (error) {
            try { targetRow.scrollIntoView(); } catch (ignore) {}
          }
        }

        if (!first) {
          first = drawer.querySelector('[data-ccd-need-input]');
        }
      }

      try { if (first) first.focus(); } catch (error) {}
    }, 120);
  }

  function resetDirectHulkSubmitState() {
    ['proc', 'sell'].forEach(function (type) {
      var host = hulkHost(type);
      if (!host) return;
      host.classList.remove('is-hulk-submitted');
      host.dataset.ccdDirectInteracted = 'false';
      host.dataset.ccdDirectInteractedAt = '0';
      host.dataset.ccdResetting = 'false';
      host.querySelectorAll('.pxFormGenerator, iframe').forEach(function (el) {
        el.style.display = '';
        el.style.visibility = '';
        el.style.opacity = '';
      });
    });
  }

  function closeRequestModal() {
    if (!requestModal || requestModal.hidden) return;

    var back = requestOpener;
    requestOpener = null;
    if (back && back !== document.body && document.contains(back)) {
      try { back.focus(); } catch (error) {}
    }

    if (ccdRequestCloseTimer) {
      clearTimeout(ccdRequestCloseTimer);
    }

    requestModal.classList.add('is-closing');
    drawer.classList.remove('is-request-modal-open');

    ccdRequestCloseTimer = setTimeout(function () {
      requestModal.hidden = true;
      requestModal.classList.remove('is-closing');
      clearRequestStatus();
      resetDirectHulkSubmitState();
      ccdRequestCloseTimer = null;
    }, 200);
  }

  function parseRequestNumber(value) {
    var cleaned = String(value || '').replace(/[^0-9]/g, '');
    var number = Number(cleaned);
    return Number.isFinite(number) && number > 0 ? number : 0;
  }

  function updateNeedHint(input) {
    if (!input) return;

    var row = input.closest('[data-ccd-request-cart-line]');
    if (!row) return;

    var hint = row.querySelector('[data-ccd-need-hint]');
    if (!hint) return;

    var needed = parseRequestNumber(input.value);
    var available = parseRequestNumber(row.getAttribute('data-available'));

    if (needed && available && needed > available) {
      hint.hidden = false;
      hint.textContent = 'We will quote the extra ' + (needed - available).toLocaleString() + ' unit' + ((needed - available) === 1 ? '' : 's') + ' beyond current availability.';
    } else {
      hint.hidden = true;
      hint.textContent = '';
    }
  }

  function buyCartLinesValue() {
    return Array.prototype.slice.call(drawer.querySelectorAll('[data-ccd-request-cart-line]')).map(function (row) {
      var needInput = row.querySelector('[data-ccd-need-input]');
      var needed = needInput ? String(needInput.value || '').trim() : '';

      if (!needed) return '';

      return [
        'Product: ' + (row.getAttribute('data-title') || ''),
        'SKU: ' + (row.getAttribute('data-sku') || ''),
        'Variant ID: ' + (row.getAttribute('data-variant-id') || ''),
        'Cart qty: ' + (row.getAttribute('data-cart-qty') || ''),
        'Qty needed: ' + needed,
        'Available now: ' + (row.getAttribute('data-available') || ''),
        'URL: ' + (row.getAttribute('data-url') || '')
      ].join('\n');
    }).filter(Boolean).join('\n\n');
  }

  function selectedFileNames(selector) {
    var files = selectedFiles(selector);

    if (!files || !files.length) return '';

    return Array.prototype.slice.call(files).map(function (file) {
      return file && file.name ? file.name : '';
    }).filter(Boolean).join(', ');
  }

  function addSummaryLine(lines, label, value) {
    value = String(value == null ? '' : value).trim();
    if (!value) return;
    lines.push(label + ': ' + value);
  }

  function requestSummaryValue() {
    var lines = [];

    addSummaryLine(lines, 'Request type', requestTypeLabel());
    addSummaryLine(lines, 'Source', requestSourceLabel());
    addSummaryLine(lines, 'Full name', requestFieldValue('full_name'));
    addSummaryLine(lines, 'Work email', requestFieldValue('work_email'));
    addSummaryLine(lines, 'Company', requestFieldValue('company'));
    addSummaryLine(lines, 'Phone', requestFieldValue('phone'));
    addSummaryLine(lines, 'Cart subtotal', requestSubtotalText());
    addSummaryLine(lines, 'Page URL', window.location.href);
    addSummaryLine(lines, 'Cart URL', window.location.origin + root + 'cart');

    if (lastCart && lastCart.token) {
      addSummaryLine(lines, 'Cart token', lastCart.token);
    }

    if (requestActiveTab === 'sell') {
      var sellFileNames = selectedFileNames('[data-ccd-sell-file]');
      var sellNotes = requestFieldValue('sell_notes');

      if (sellFileNames) {
        lines.push('', 'Sell inventory file selected: ' + sellFileNames);
      }

      if (sellNotes) {
        lines.push('', 'Sell notes:', sellNotes);
      }
    } else if (requestActiveTab === 'proc') {
      var procurementFileNames = selectedFileNames('[data-ccd-procurement-file]');
      var procurementItems = procurementRowsValue();

      if (procurementFileNames) {
        lines.push('', 'Procurement file selected: ' + procurementFileNames);
      }

      if (procurementItems) {
        lines.push('', 'Procurement items:', procurementItems);
      }
    } else {
      var cartItems = buyCartLinesValue();

      if (cartItems) {
        lines.push('', 'Cart items:', cartItems);
      }
    }

    return lines.join('\n').replace(/\n{3,}/g, '\n\n').trim();
  }

  function procurementRowsValue() {
    return Array.prototype.slice.call(drawer.querySelectorAll('[data-ccd-procurement-row]')).map(function (row) {
      var mpn = row.querySelector('[data-ccd-proc-mpn]');
      var qty = row.querySelector('[data-ccd-proc-qty]');
      var desc = row.querySelector('[data-ccd-proc-desc]');

      mpn = mpn ? String(mpn.value || '').trim() : '';
      qty = qty ? String(qty.value || '').trim() : '';
      desc = desc ? String(desc.value || '').trim() : '';

      if (!mpn && !qty && !desc) return '';

      return [
        'MPN: ' + (mpn || 'Not specified'),
        'Qty: ' + (qty || 'Not specified'),
        'Description: ' + (desc || 'Not specified')
      ].join('\n');
    }).filter(Boolean).join('\n\n');
  }

  function selectedFiles(selector) {
    var input = drawer.querySelector(selector);
    return input && input.files ? input.files : null;
  }

  function hasSelectedFiles(selector) {
    var files = selectedFiles(selector);
    return !!(files && files.length);
  }

  function requestSubtotalText() {
    return subtotalEl ? String(subtotalEl.textContent || '').trim() : '';
  }

  function requestTypeLabel() {
    if (requestActiveTab === 'sell') return 'Sell to us';
    if (requestActiveTab === 'proc') return 'Procurement request';
    return 'Bulk / high volume quote';
  }

  function requestSourceLabel() {
    if (requestIntent === 'bulk_line') return 'Cart product bulk request button';
    if (requestIntent === 'procurement') return 'Need a part we do not stock button';
    if (requestIntent === 'sell') return 'Have surplus drives button';
    return 'Bulk request';
  }

  function normText(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[\-_]+/g, ' ')
      .replace(/[’']/g, '')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function labelTextForField(scope, field) {
    var pieces = [];
    var id = field.getAttribute('id');

    if (id) {
      try {
        var label = scope.querySelector('label[for="' + id.replace(/"/g, '\\"') + '"]');
        if (label) pieces.push(label.textContent || '');
      } catch (error) {}
    }

    var parentLabel = field.closest ? field.closest('label') : null;
    if (parentLabel) pieces.push(parentLabel.textContent || '');

    return pieces.join(' ');
  }

  function hulkFieldMatches(scope, field, aliases) {
    var candidates = [
      field.getAttribute('name'),
      field.getAttribute('id'),
      field.getAttribute('placeholder'),
      field.getAttribute('aria-label'),
      field.getAttribute('data-name'),
      field.getAttribute('data-label'),
      field.getAttribute('data-field-label'),
      labelTextForField(scope, field)
    ].map(normText).filter(Boolean);

    return aliases.some(function (alias) {
      var wanted = normText(alias);
      if (!wanted) return false;

      return candidates.some(function (candidate) {
        return candidate === wanted || candidate.indexOf(wanted) !== -1 || wanted.indexOf(candidate) !== -1;
      });
    });
  }

  function findHulkField(scope, aliases, fileOnly) {
    if (!scope) return null;

    var selector = fileOnly ? 'input[type="file"]' : 'input, textarea, select';
    var fields = Array.prototype.slice.call(scope.querySelectorAll(selector));

    return fields.find(function (field) {
      if (!fileOnly) {
        var type = String(field.type || '').toLowerCase();
        if (type === 'submit' || type === 'button' || type === 'reset' || type === 'file') return false;
      }

      return hulkFieldMatches(scope, field, aliases);
    }) || null;
  }

  function setHulkValue(scope, aliases, value) {
    var field = findHulkField(scope, aliases, false);
    if (!field) return false;

    if (field.type === 'checkbox') {
      field.checked = !!value;
    } else {
      field.value = value == null ? '' : String(value);
    }

    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function copyFilesToHulk(scope, aliases, files) {
    if (!files || !files.length) return true;

    var field = findHulkField(scope, aliases, true);
    if (!field) return false;

    try {
      var dt = new DataTransfer();
      Array.prototype.slice.call(files).forEach(function (file) { dt.items.add(file); });
      field.files = dt.files;
      field.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    } catch (error) {
      console.warn('Could not attach files to Hulk file field:', error);
      return false;
    }
  }

  function hulkAliases(type, key) {
    var common = {
      request_summary: ['request_summary', 'request summary', 'summary', 'request details'],
      full_name: ['full_name', 'full name'],
      work_email: ['work_email', 'work email', 'email'],
      company: ['company', 'company name'],
      phone: ['phone', 'phone number'],
      request_type: ['request_type', 'request type'],
      source_button: ['source_button', 'source button', 'request source'],
      page_url: ['page_url', 'page url', 'source page'],
      cart_url: ['cart_url', 'cart url'],
      cart_subtotal: ['cart_subtotal', 'cart subtotal'],
      cart_token: ['cart_token', 'cart token']
    };

    var bulk = {
      cart_items: ['cart_items', 'cart items', 'products requested', 'cart products', 'bulk items', 'requested products']
    };

    var procurement = {
      procurement_items: ['procurement_items', 'procurement items', 'parts requested', 'parts to source', 'parts we dont stock'],
      procurement_file: ['procurement_file', 'procurement file', 'bom file', 'parts list file']
    };

    var sell = {
      sell_notes: ['sell_notes', 'sell notes', 'anything we should know', 'surplus notes'],
      sell_file: ['sell_file', 'sell file', 'inventory file', 'drive list file']
    };

    if (common[key]) return common[key];
    if (type === 'sell') return sell[key] || [key];
    if (type === 'proc') return procurement[key] || [key];
    return bulk[key] || [key];
  }

  function hulkHost(type) {
    return drawer.querySelector('[data-ccd-hulk-form="' + type + '"]') ||
      document.querySelector('[data-ccd-owner="' + drawer.id + '"] [data-ccd-hulk-form="' + type + '"]');
  }

  var ccdBulkHulkAuthorizedUntil = 0;
  var ccdBulkHulkGuardObserver = null;

  function hulkSubmitSelector() {
    return [
      'button[type="submit"]',
      'input[type="submit"]',
      'button[name="submit"]',
      'input[name="submit"]',
      '[data-submit]',
      '.hulk-form-submit',
      '.formBuilderSubmit',
      '.submit',
      '.btn-submit'
    ].join(',');
  }

  function hulkSubmitTarget(host) {
    if (!host) return null;

    var form = host.querySelector('form') || (host.matches && host.matches('form') ? host : null);
    var submitButton = host.querySelector(hulkSubmitSelector());

    if (form || submitButton) {
      return { form: form, submitButton: submitButton };
    }

    return null;
  }

  function bulkHulkSubmitAuthorized(host) {
    return !!(host && host === hulkHost('bulk') && Date.now() <= ccdBulkHulkAuthorizedUntil);
  }

  function authorizeBulkHulkSubmit(host) {
    if (!host || host !== hulkHost('bulk')) return;

    ccdBulkHulkAuthorizedUntil = Date.now() + 4000;
    host.dataset.ccdBulkSubmitAuthorized = 'true';

    setTimeout(function () {
      if (Date.now() > ccdBulkHulkAuthorizedUntil) {
        host.dataset.ccdBulkSubmitAuthorized = 'false';
      }
    }, 4100);
  }

  function basicGeneratedSummaryIsValid(summary) {
    summary = String(summary || '').trim();
    if (summary.length < 80) return false;

    return [
      'Request type:',
      'Source:',
      'Page URL:',
      'Cart URL:'
    ].every(function (marker) {
      return summary.indexOf(marker) !== -1;
    });
  }

  function guardBulkHulkHost() {
    var host = hulkHost('bulk');
    if (!host) return;

    host.setAttribute('aria-hidden', 'true');
    host.dataset.ccdBulkBridge = 'true';

    function lockFocus() {
      host.querySelectorAll('a[href], button, input, select, textarea, iframe, [tabindex]').forEach(function (element) {
        if (!element.hasAttribute('data-ccd-original-tabindex')) {
          var originalTabindex = element.getAttribute('tabindex');
          element.setAttribute('data-ccd-original-tabindex', originalTabindex == null ? '' : originalTabindex);
        }
        element.setAttribute('tabindex', '-1');
      });
    }

    function wireForm(form) {
      if (!form || form.dataset.ccdBulkGuardAttached === 'true') return;
      form.dataset.ccdBulkGuardAttached = 'true';

      form.addEventListener('submit', function (event) {
        if (bulkHulkSubmitAuthorized(host)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        console.warn('Blocked unauthorized hidden Hulk Bulk form submission.');
      }, true);

      if (typeof form.submit === 'function' && !form.__ccdBulkOriginalSubmit) {
        try {
          form.__ccdBulkOriginalSubmit = form.submit;
          form.submit = function () {
            if (!bulkHulkSubmitAuthorized(host)) {
              console.warn('Blocked unauthorized direct Hulk Bulk form.submit().');
              return;
            }
            return form.__ccdBulkOriginalSubmit.call(form);
          };
        } catch (error) {
          console.warn('Could not wrap Hulk Bulk form.submit(); submit-event guard remains active.', error);
        }
      }
    }

    function scan() {
      lockFocus();
      host.querySelectorAll('form').forEach(wireForm);
    }

    if (host.dataset.ccdBulkClickGuardAttached !== 'true') {
      host.dataset.ccdBulkClickGuardAttached = 'true';
      host.addEventListener('click', function (event) {
        var target = event.target && event.target.closest ? event.target.closest(hulkSubmitSelector()) : null;
        if (!target || !host.contains(target) || bulkHulkSubmitAuthorized(host)) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        console.warn('Blocked unauthorized hidden Hulk Bulk submit click.');
      }, true);
    }

    scan();

    if (!ccdBulkHulkGuardObserver) {
      ccdBulkHulkGuardObserver = new MutationObserver(scan);
      ccdBulkHulkGuardObserver.observe(host, { childList: true, subtree: true });
    }
  }

  function waitForHulkTarget(type, timeoutMs) {
    var host = hulkHost(type);

    if (!host) {
      return Promise.reject(new Error('Hulk form host not found for ' + type + '.'));
    }

    var immediateTarget = hulkSubmitTarget(host);
    if (immediateTarget) {
      return Promise.resolve(immediateTarget);
    }

    return new Promise(function (resolve, reject) {
      var done = false;
      var observer = null;

      function finish(target) {
        if (done) return;
        done = true;
        if (observer) observer.disconnect();
        clearTimeout(timer);
        resolve(target);
      }

      function fail() {
        if (done) return;
        done = true;
        if (observer) observer.disconnect();

        var iframe = host.querySelector('iframe');
        if (iframe) {
          reject(new Error(type === 'bulk' ? 'The Hulk Bulk form did not expose editable fields in time. The Bulk embed is present, but Hulk is still rendering it as an iframe or delaying the normal fields. Please refresh and try again.' : 'The Hulk ' + type + ' form appears to be inside an iframe, so this cart drawer cannot auto-fill it directly. Use Hulk embedded HTML that renders fields on the page, or expose the form fields outside the iframe.'));
          return;
        }

        reject(new Error('The Hulk ' + type + ' form embed was found, but the form fields did not finish loading yet. Please refresh and try again. If it keeps happening, confirm the embed code is inside data-ccd-hulk-form="' + type + '".'));
      }

      function check() {
        var target = hulkSubmitTarget(host);
        if (target) finish(target);
      }

      observer = new MutationObserver(check);
      observer.observe(host, { childList: true, subtree: true });

      var timer = setTimeout(fail, timeoutMs || 8000);

      check();
    });
  }

  function submitHulk(type, payload, files) {
    var host = hulkHost(type);
    if (!host) {
      return Promise.reject(new Error('Hulk form host not found.'));
    }

    if (type === 'bulk') {
      guardBulkHulkHost();
      if (!basicGeneratedSummaryIsValid(payload && payload.request_summary)) {
        return Promise.reject(new Error('Bulk request was blocked because the generated request summary was incomplete. Please refresh and try again.'));
      }
    }

    return waitForHulkTarget(type, type === 'bulk' ? 18000 : 8000).then(function (target) {
      Object.keys(payload).forEach(function (key) {
        var ok = setHulkValue(host, hulkAliases(type, key), payload[key]);
        if (!ok) console.warn('Hulk field not found for:', key, hulkAliases(type, key));
      });

      if (type === 'proc') {
        if (!copyFilesToHulk(host, hulkAliases(type, 'procurement_file'), files && files.procurement)) {
          if (files && files.procurement && files.procurement.length) {
            throw new Error('The selected BOM file could not be attached. Add a File Upload field labeled Procurement File in the Procurement Hulk form.');
          }
        }
      }

      if (type === 'sell') {
        if (!copyFilesToHulk(host, hulkAliases(type, 'sell_file'), files && files.sell)) {
          if (files && files.sell && files.sell.length) {
            throw new Error('The selected inventory file could not be attached. Add a File Upload field labeled Sell File in the Sell Hulk form.');
          }
        }
      }

      if (type === 'bulk') {
        authorizeBulkHulkSubmit(host);
      }

      if (target.submitButton) {
        target.submitButton.click();
        return;
      }

      if (target.form && typeof target.form.requestSubmit === 'function') {
        target.form.requestSubmit();
        return;
      }

      if (target.form) {
        if (type === 'bulk' && !bulkHulkSubmitAuthorized(host)) {
          throw new Error('Bulk request authorization expired before submission. Please try again.');
        }

        if (typeof HTMLFormElement !== 'undefined' && HTMLFormElement.prototype && typeof HTMLFormElement.prototype.submit === 'function') {
          HTMLFormElement.prototype.submit.call(target.form);
        } else if (typeof target.form.submit === 'function') {
          target.form.submit();
        }
      }
    });
  }

  function hulkHostHasIframe(type) {
    var host = hulkHost(type);
    return !!(host && host.querySelector('iframe'));
  }

  function isHulkIframeError(error) {
    var message = String(error && error.message ? error.message : error || '').toLowerCase();
    return message.indexOf('iframe') !== -1 || message.indexOf('could not be attached') !== -1;
  }

  function submitHulkWithFallback(type, payload, files) {
    return submitHulk(type, payload, files).catch(function (error) {
      if (type === 'bulk' || (!hulkHostHasIframe(type) && !isHulkIframeError(error))) {
        throw error;
      }

      console.warn('Hulk ' + type + ' form is iframe/file-upload blocked. Routing through the working Bulk Hulk form instead.', error);

      payload = Object.assign({}, payload, {
        request_summary: String(payload.request_summary || '') + '\n\nInternal routing note: The ' + type + ' Hulk form rendered inside an iframe or blocked file auto-fill, so the request was submitted through the Bulk Hulk form. Selected file names are listed above, but files are not attached by this fallback.'
      });

      
      return submitHulk('bulk', payload, {});
    });
  }

  function validateRequestContact() {
    var name = requestFieldValue('full_name');
    var email = requestFieldValue('work_email');
    var company = requestFieldValue('company');

    if (!requestNameIsValid(name)) {
      requestStatus('Please enter your full name (at least 2 letters).', true);
      focusInvalidRequestField(requestField('full_name'));
      return false;
    }

    if (!requestEmailIsValid(email)) {
      requestStatus('Please enter a valid business email address.', true);
      focusInvalidRequestField(requestField('work_email'));
      return false;
    }

    if (!requestCompanyIsValid(company)) {
      requestStatus('Please enter your company name.', true);
      focusInvalidRequestField(requestField('company'));
      return false;
    }

    return true;
  }

  function validateRequestDetails() {
    if (requestActiveTab === 'bulk') {
      var needInputs = Array.prototype.slice.call(drawer.querySelectorAll('[data-ccd-need-input]'));
      if (!needInputs.length) {
        requestStatus('Add at least one cart item before sending a bulk request.', true);
        return false;
      }

      var filledNeedInputs = needInputs.filter(function (input) {
        return !!String(input.value || '').trim();
      });

      if (!filledNeedInputs.length) {
        requestStatus('Enter qty needed for at least one cart item.', true);
        focusInvalidRequestField(needInputs[0]);
        return false;
      }

      var invalidNeedInput = filledNeedInputs.find(function (input) {
        return !strictRequestQuantity(input.value);
      });

      if (invalidNeedInput) {
        requestStatus('Quantity must be a whole number from 1 to 999,999.', true);
        focusInvalidRequestField(invalidNeedInput);
        return false;
      }
    }

    if (requestActiveTab === 'proc') {
      if (!procurementRowsValue() && !hasSelectedFiles('[data-ccd-procurement-file]')) {
        requestStatus('Upload a BOM or enter at least one part to source.', true);
        focusInvalidRequestField(drawer.querySelector('[data-ccd-proc-mpn]'));
        return false;
      }
    }

    if (requestActiveTab === 'sell') {
      if (!requestFieldValue('sell_notes') && !hasSelectedFiles('[data-ccd-sell-file]')) {
        requestStatus('Upload an inventory file or add a note about the drives you want to sell.', true);
        focusInvalidRequestField(requestField('sell_notes'));
        return false;
      }
    }

    return true;
  }

  function validateGeneratedRequestSummary(summary) {
    summary = String(summary || '').trim();

    if (!basicGeneratedSummaryIsValid(summary)) {
      return 'The request summary could not be generated correctly. Please refresh and try again.';
    }

    if (requestActiveTab === 'bulk') {
      var requiredBulkMarkers = ['Full name:', 'Work email:', 'Company:', 'Cart items:', 'Qty needed:'];
      var missingBulkMarker = requiredBulkMarkers.find(function (marker) {
        return summary.indexOf(marker) === -1;
      });

      if (missingBulkMarker) {
        return 'The bulk request is missing required customer or product details. Please review the form and try again.';
      }
    }

    return '';
  }

  function buildRequestPayload(summary) {
    var payload = {
      request_summary: summary,
      full_name: requestFieldValue('full_name'),
      work_email: requestFieldValue('work_email'),
      company: requestFieldValue('company'),
      phone: requestFieldValue('phone'),
      request_type: requestTypeLabel(),
      source_button: requestSourceLabel(),
      page_url: window.location.href,
      cart_url: window.location.origin + root + 'cart',
      cart_subtotal: requestSubtotalText(),
      cart_token: lastCart && lastCart.token ? lastCart.token : ''
    };

    if (requestActiveTab === 'bulk') {
      payload.cart_items = buyCartLinesValue();
    } else if (requestActiveTab === 'proc') {
      payload.procurement_items = procurementRowsValue();
    } else if (requestActiveTab === 'sell') {
      payload.sell_notes = requestFieldValue('sell_notes');
    }

    return payload;
  }

  function submitRequestModal() {
    if (!validateRequestContact() || !validateRequestDetails()) return;

    var summary = requestSummaryValue();
    var summaryError = validateGeneratedRequestSummary(summary);
    if (summaryError) {
      requestStatus(summaryError, true);
      return;
    }

    var submit = drawer.querySelector('[data-ccd-request-submit]');
    if (submit) {
      submit.dataset.originalText = submit.textContent || '';
      submit.textContent = 'Sending...';
      submit.classList.add('is-loading');
      submit.disabled = true;
    }

    clearRequestStatus();

    var commonPayload = buildRequestPayload(summary);

    var submitPromise;

    if (requestActiveTab === 'sell') {
      submitPromise = submitHulkWithFallback('sell', commonPayload, {
        sell: selectedFiles('[data-ccd-sell-file]')
      });
    } else if (requestActiveTab === 'proc') {
      submitPromise = submitHulkWithFallback('proc', commonPayload, {
        procurement: selectedFiles('[data-ccd-procurement-file]')
      });
    } else {
      submitPromise = submitHulkWithFallback('bulk', commonPayload, {});
    }

    Promise.resolve(submitPromise)
      .then(function () {
        requestStatus('Request submitted. We will reply within 1 business day.', false);
      })
      .catch(function (error) {
        console.error(error);
        requestStatus(error && error.message ? error.message : 'Unable to submit request. Please try again.', true);
      })
      .finally(function () {
        if (submit) {
          setTimeout(function () {
            submit.classList.remove('is-loading');
            submit.disabled = false;
            updateRequestSubmitText();
          }, 900);
        }
      });
  }
  if (procurementListEl) {
    ensureProcurementRow();
  }

  drawer.addEventListener('click', function (event) {
    var requestTrigger = event.target.closest('[data-ccd-open-request]');
    var requestClose = event.target.closest('[data-ccd-request-close]');
    var requestTab = event.target.closest('[data-ccd-request-tab]');
    var addProc = event.target.closest('[data-ccd-add-procurement]');
    var removeProc = event.target.closest('[data-ccd-remove-procurement]');
    var drop = event.target.closest('[data-ccd-drop]');
    var submitRequest = event.target.closest('[data-ccd-request-submit]');

    if (requestTrigger && drawer.contains(requestTrigger)) {
      event.preventDefault();
      openRequestModal(
        requestTrigger.getAttribute('data-ccd-request-tab'),
        requestTrigger.getAttribute('data-ccd-request-intent'),
        requestTrigger.getAttribute('data-ccd-request-line-key'),
        requestTrigger.getAttribute('data-open')
      );
      return;
    }

    if (requestClose && drawer.contains(requestClose)) {
      event.preventDefault();
      closeRequestModal();
      return;
    }

    if (requestTab && drawer.contains(requestTab)) {
      event.preventDefault();
      var nextRequestTab = normalizeRequestTab(requestTab.getAttribute('data-ccd-request-tab'));
      requestIntent = requestIntentForTab(nextRequestTab);
      setRequestTab(nextRequestTab);
      clearRequestStatus();
      return;
    }

    if (addProc && drawer.contains(addProc)) {
      event.preventDefault();
      addProcurementRow('', '', '');
      return;
    }

    if (removeProc && drawer.contains(removeProc)) {
      event.preventDefault();
      var row = removeProc.closest('[data-ccd-procurement-row]');
      if (row) row.remove();
      ensureProcurementRow();
      return;
    }

    if (drop && drawer.contains(drop)) {
      var fileInput = drop.querySelector('input[type="file"]');
      if (fileInput && event.target !== fileInput) {
        event.preventDefault();
        fileInput.click();
      }
      return;
    }

    if (submitRequest && drawer.contains(submitRequest)) {
      event.preventDefault();
      submitRequestModal();
    }
  });

  drawer.addEventListener('input', function (event) {
    var needInput = event.target.closest('[data-ccd-need-input]');
    if (needInput && drawer.contains(needInput)) {
      updateNeedHint(needInput);
    }
  });

  drawer.addEventListener('change', function (event) {
    var procurementFile = event.target.closest('[data-ccd-procurement-file]');
    var sellFile = event.target.closest('[data-ccd-sell-file]');

    if (procurementFile && drawer.contains(procurementFile)) {
      setFileLabel('procurement', procurementFile.files);
    }

    if (sellFile && drawer.contains(sellFile)) {
      setFileLabel('sell', sellFile.files);
    }
  });

  drawer.querySelectorAll('[data-ccd-drop]').forEach(function (drop) {
    ['dragenter', 'dragover'].forEach(function (eventName) {
      drop.addEventListener(eventName, function (event) {
        event.preventDefault();
        drop.classList.add('is-dragging');
      });
    });

    ['dragleave', 'drop'].forEach(function (eventName) {
      drop.addEventListener(eventName, function (event) {
        event.preventDefault();
        drop.classList.remove('is-dragging');
      });
    });

    drop.addEventListener('drop', function (event) {
      var fileInput = drop.querySelector('input[type="file"]');
      if (!fileInput || !event.dataTransfer || !event.dataTransfer.files || !event.dataTransfer.files.length) return;

      try {
        var dt = new DataTransfer();
        Array.prototype.slice.call(event.dataTransfer.files).forEach(function (file) { dt.items.add(file); });
        fileInput.files = dt.files;
        fileInput.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (error) {
        console.warn('Could not attach dropped files:', error);
      }
    });
  });

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cart-drawer-open], .site-header-cart-button');
    var close = e.target.closest('[data-cart-drawer-close]');
    var remove = e.target.closest('[data-remove-key]');
    var upsell = e.target.closest('[data-add-upsell]');

    if (open) {
      e.preventDefault();
      openDrawer();
    }

    if (close && drawer.contains(close)) {
      e.preventDefault();
      closeDrawer();
    }

    if (remove && drawer.contains(remove)) {
      e.preventDefault();

      if (remove.dataset.removing === 'true') return;
      remove.dataset.removing = 'true';

      setRemoveLoading(remove, true);

      changeLine(remove.getAttribute('data-remove-key'), 0)
        .catch(function (error) {
          console.error('Cart drawer remove error:', error);
          setRemoveLoading(remove, false);
          remove.dataset.removing = 'false';
        });
    }

    if (upsell && drawer.contains(upsell)) {
      e.preventDefault();
      addVariant(upsell.getAttribute('data-variant-id'));
    }
  });

  function updateQuantityFromControl(control, requestedQty) {
    var wrap = control.closest('[data-qty-wrap], [data-line-key]');
    if (!wrap) return;

    clearQtyCommitTimer(wrap);
    markCheckoutPending();

    if (wrap.dataset.qtyUpdating === 'true' || ccdCartActionInProgress) {
      return;
    }

    requestedQty = Number(requestedQty);

    var currentQty = Number(wrap.getAttribute('data-current-qty') || 1);
    var lineKey = wrap.getAttribute('data-line-key') || '';
    var variantId = wrap.getAttribute('data-variant-id');
    var rawStock = variantStockMap[String(variantId)];
    var stock = rawStock === null || rawStock === undefined || rawStock === '' ? null : Number(rawStock);

    clearDrawerError();

    if (!Number.isFinite(requestedQty) || requestedQty < 1) {
      requestedQty = currentQty;
    }

    requestedQty = Math.floor(requestedQty);
    var originalRequestedQty = requestedQty;

    if (stock !== null && Number.isFinite(stock) && stock <= 0) {
      control.value = String(currentQty);
      setLineStockMessage(
        lineKey,
        'This item is not available online right now. Use the bulk request button below and we will check availability for you.'
      );
      restoreCheckoutFromConfirmedCart();
      return;
    }

    if (requestedQty === currentQty) {
      restoreCheckoutFromConfirmedCart();
      return;
    }

    var requestToken = lineKey + ':' + requestedQty;
    var lastRequestAt = Number(wrap.dataset.lastQtyRequestAt || 0);
    if (wrap.dataset.lastQtyRequest === requestToken && Date.now() - lastRequestAt < 1800) {
      restoreCheckoutFromConfirmedCart();
      return;
    }

    wrap.dataset.lastQtyRequest = requestToken;
    wrap.dataset.lastQtyRequestAt = String(Date.now());
    wrap.dataset.qtyUpdating = 'true';
    wrap.classList.add('is-loading');
    beginCartUpdateLock(wrap);
    wrap.querySelectorAll('select, input').forEach(function (field) {
      field.disabled = true;
    });

    changeLine(lineKey, requestedQty, {
      suppressGlobalError: true,
      originalRequestedQty: originalRequestedQty
    })
      .finally(function () {
        wrap.classList.remove('is-loading');
        wrap.dataset.qtyUpdating = 'false';
        wrap.querySelectorAll('select, input').forEach(function (field) {
          field.disabled = false;
        });
        endCartUpdateLock();
      });
  }


  function replaceQtySelectWithInput(select) {
    var wrap = select.closest('[data-qty-wrap]');
    if (!wrap) return;

    markCheckoutPending();

    var input = document.createElement('input');
    input.className = 'ccd__qty ccd__qty-input';
    input.setAttribute('data-qty-input', '');
    if (select.getAttribute('aria-label')) input.setAttribute('aria-label', select.getAttribute('aria-label'));
    input.type = 'number';
    input.inputMode = 'numeric';
    input.min = '1';
    input.value = '10';

    select.replaceWith(input);

    setTimeout(function () {
      input.focus();
      input.select();
    }, 30);

    // If the customer selects 10+ and immediately tries checkout, keep checkout
    // locked. Commit 10 automatically unless they type a different value first.
    scheduleQtyCommit(input, 700);
  }

  drawer.addEventListener('input', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input || !drawer.contains(input)) return;

    markCheckoutPending();
    scheduleQtyCommit(input, 700);
  });

  drawer.addEventListener('change', function (e) {
    var select = e.target.closest('[data-qty-select]');
    var input = e.target.closest('[data-qty-input]');

    if (select && drawer.contains(select)) {
      e.preventDefault();
      e.stopPropagation();

      if (select.value === '10plus') {
        replaceQtySelectWithInput(select);
        return;
      }

      updateQuantityFromControl(select, select.value);
      return;
    }

    if (input && drawer.contains(input)) {
      e.preventDefault();
      e.stopPropagation();
      clearQtyCommitTimer(input.closest('[data-qty-wrap]'));
      updateQuantityFromControl(input, input.value);
      return;
    }

    var qty = e.target.closest('[data-line-key]');
    if (qty && drawer.contains(qty)) {
      updateQuantityFromControl(qty, qty.value);
    }
  });

  drawer.addEventListener('keydown', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input || !drawer.contains(input)) return;

    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      clearQtyCommitTimer(input.closest('[data-qty-wrap]'));
      updateQuantityFromControl(input, input.value);
    }

    if (e.key === 'Escape') {
      var wrap = input.closest('[data-qty-wrap]');
      var currentQty = wrap ? Number(wrap.getAttribute('data-current-qty') || 1) : 1;
      input.value = currentQty;
      input.blur();
    }
  });

  drawer.addEventListener('blur', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input || !drawer.contains(input)) return;

    if (input.value === '') {
      var wrap = input.closest('[data-qty-wrap]');
      input.value = wrap ? (wrap.getAttribute('data-current-qty') || '1') : '1';
    }

    e.stopPropagation();
    clearQtyCommitTimer(input.closest('[data-qty-wrap]'));
    updateQuantityFromControl(input, input.value);
  }, true);

  if (noteEl) {
    var noteTimer;
    noteEl.addEventListener('input', function () {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ note: noteEl.value })
        });
      }, 500);
    });
  }

  if (shippingToggles && shippingToggles.length) {
    shippingToggles.forEach(function (toggle) {
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        toggleShippingCalculator();
      });
    });
  }

  if (shippingCountry) {
    renderShippingProvinces();

    shippingCountry.addEventListener('change', function () {
      renderShippingProvinces();

      if (shippingResult) {
        shippingResult.hidden = true;
        shippingResult.innerHTML = '';
      }
    });
  }

  if (shippingButton) {
    shippingButton.addEventListener('click', getShippingRates);
  }

  if (shippingZip) {
    shippingZip.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        getShippingRates();
      }
    });
  }


  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    wrapTabInLayer(e);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (highValueModalEl && !highValueModalEl.hidden) {
        closeHighValueCheckoutModal();
        return;
      }

      if (requestModal && !requestModal.hidden) {
        closeRequestModal();
        return;
      }

      closeDrawer();
    }
  });

  drawer.querySelectorAll('[data-ccd-high-value-modal-close]').forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      closeHighValueCheckoutModal();
    });
  });

  function scheduleExternalCartRefresh(shouldOpen) {
    if (ccdCartActionInProgress || ccdRefreshPromise) return;
    if (Date.now() - ccdLastInternalCartActionAt < 2500) return;

    clearTimeout(ccdExternalRefreshTimer);
    ccdExternalRefreshTimer = setTimeout(function () {
      if (ccdCartActionInProgress || ccdRefreshPromise) return;
      if (Date.now() - ccdLastInternalCartActionAt < 2500) return;

      if (shouldOpen) {
        openDrawer({ skipRefresh: true });
      }

      refreshCart({ silent: shouldOpen });
    }, 300);
  }

  document.addEventListener('cart:refresh', function () {
    scheduleExternalCartRefresh(false);
  });
  document.addEventListener('cart:updated', function () {
    scheduleExternalCartRefresh(true);
  });
  document.addEventListener('cart:change', function () {
    scheduleExternalCartRefresh(false);
  });
  document.addEventListener('ajaxCart:updated', function () {
    scheduleExternalCartRefresh(true);
  });
  document.addEventListener('product:added', function () {
    scheduleExternalCartRefresh(true);
  });

  window.CustomCartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshCart
  };

  if (checkoutFormEl) {
    checkoutFormEl.addEventListener('submit', function (event) {
      var isReady = checkoutFormEl.dataset.ccdCheckoutReady === 'true';
      var isBlocked = checkoutFormEl.dataset.ccdCheckoutBlocked === 'true';
      var isChecking = checkoutFormEl.dataset.ccdCheckoutChecking === 'true';

      if (isReady && !isBlocked && !isChecking) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      // A pending quantity/cart update has no confirmed total yet. Keep checkout
      // fully locked; only a confirmed over-limit cart should open the modal.
      if (isChecking || !isReady) return;
      if (isBlocked) openHighValueCheckoutModal();
    }, true);
  }

  if (ajaxForms) {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();

      fetch(root + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (r) {
          if (!r.ok) throw r;
          return r.json();
        })
        .then(function () {
          return openDrawer();
        })
        .catch(function (err) {
          console.error('Cart drawer add error:', err);
        });
    });
  }



  function directHulkConfirmationMessage(type) {
    return type === 'sell'
      ? 'Sell to us request submitted. We will reply within 1 business day.'
      : 'Procurement request submitted. We will reply within 1 business day.';
  }

  function directHulkConfirmationSubtext(type) {
    return type === 'sell'
      ? 'Thank you. Our purchasing team will review your inventory list and follow up.'
      : 'Thank you. Our team will review your BOM / parts list and follow up.';
  }

  function ensureDirectHulkSuccessCard(type) {
    return null;
  }

  function showDirectHulkSuccess(type) {
    var host = hulkHost(type);

    if (host) {
      host.classList.add('is-hulk-submitted');
    }

    if (requestModal) {
      requestModal.classList.add('is-direct-hulk-success');
      requestModal.classList.add('is-request-success-view');
    }

    requestStatus(directHulkConfirmationMessage(type), false);

    if (requestBodyEl) {
      requestBodyEl.scrollTop = 0;
    }
  }

  function primeDirectHulkConfirmation(type) {
    var host = hulkHost(type);
    if (!host) return;

    ensureDirectHulkSuccessCard(type);

    host.querySelectorAll('iframe').forEach(function (iframe) {
      iframe.dataset.ccdInitialLoadSeen = 'true';
      iframe.dataset.ccdPrimedAt = String(Date.now());
    });
  }

  function attachDirectHulkIframeWatcher(type) {
    var host = hulkHost(type);
    if (!host || host.dataset.ccdDirectWatchAttached === 'true') return;

    host.dataset.ccdDirectWatchAttached = 'true';
    ensureDirectHulkSuccessCard(type);

    function isActiveDirectTab() {
      return requestModal && !requestModal.hidden && requestActiveTab === type;
    }

    function markIframeInteracted(iframe) {
      if (!iframe) return;
      iframe.dataset.ccdInteracted = 'true';
      host.dataset.ccdDirectInteracted = 'true';
      host.dataset.ccdDirectInteractedAt = String(Date.now());
    }

    function shouldTreatIframeLoadAsSubmitted(iframe) {
      if (!isActiveDirectTab()) return false;
      if (host.dataset.ccdResetting === 'true') return false;

      var interacted = iframe.dataset.ccdInteracted === 'true' || host.dataset.ccdDirectInteracted === 'true';
      var interactedAt = Number(host.dataset.ccdDirectInteractedAt || 0);
      var now = Date.now();

      return !!(interacted && interactedAt && now - interactedAt > 300);
    }

    function wireIframe(iframe) {
      if (!iframe || iframe.dataset.ccdHulkLoadWatcher === 'true') return;

      iframe.dataset.ccdHulkLoadWatcher = 'true';
      iframe.dataset.ccdWiredAt = String(Date.now());

      ['mouseenter', 'pointerdown', 'mousedown', 'touchstart', 'click', 'focus'].forEach(function (eventName) {
        iframe.addEventListener(eventName, function () {
          markIframeInteracted(iframe);
        }, true);
      });

      iframe.addEventListener('load', function () {
        if (host.dataset.ccdResetting === 'true') {
          iframe.dataset.ccdInitialLoadSeen = 'true';
          iframe.dataset.ccdInteracted = 'false';
          iframe.dataset.ccdPrimedAt = String(Date.now());
          return;
        }

        if (shouldTreatIframeLoadAsSubmitted(iframe)) {
          setTimeout(function () {
            showDirectHulkSuccess(type);
          }, 250);
          return;
        }

        iframe.dataset.ccdInitialLoadSeen = 'true';
        iframe.dataset.ccdPrimedAt = String(Date.now());
      });

      setTimeout(function () {
        iframe.dataset.ccdInitialLoadSeen = 'true';
        iframe.dataset.ccdPrimedAt = String(Date.now());
      }, 1200);
    }

    function wireDirectForm(form) {
      if (!form || form.dataset.ccdHulkSubmitWatcher === 'true') return;
      form.dataset.ccdHulkSubmitWatcher = 'true';
      form.addEventListener('submit', function () {
        setTimeout(function () {
          if (isActiveDirectTab()) {
            showDirectHulkSuccess(type);
          }
        }, 900);
      }, true);
    }

    function scanDirectHulkForm() {
      host.querySelectorAll('iframe').forEach(wireIframe);
      host.querySelectorAll('form').forEach(wireDirectForm);
    }

    scanDirectHulkForm();

    var observer = new MutationObserver(function () {
      scanDirectHulkForm();
    });
    observer.observe(host, { childList: true, subtree: true });

    window.addEventListener('blur', function () {
      setTimeout(function () {
        var active = document.activeElement;
        if (active && active.tagName && active.tagName.toLowerCase() === 'iframe' && host.contains(active)) {
          markIframeInteracted(active);
        }
      }, 0);
    }, true);

    window.addEventListener('message', function (event) {
      if (!isActiveDirectTab()) return;

      var data = '';
      try {
        data = typeof event.data === 'string' ? event.data : JSON.stringify(event.data || {});
      } catch (error) {
        data = '';
      }

      data = data.toLowerCase();
      if (data.indexOf('success') !== -1 || data.indexOf('submit') !== -1 || data.indexOf('thank') !== -1 || data.indexOf('complete') !== -1) {
        showDirectHulkSuccess(type);
      }
    });
  }

  function attachDirectHulkConfirmationWatchers() {
    attachDirectHulkIframeWatcher('proc');
    attachDirectHulkIframeWatcher('sell');
  }


  attachDirectHulkConfirmationWatchers();
  guardBulkHulkHost();

  refreshCart();
})();
